import IQBOSyncInvoicesUpdateDTO from "../../../models/DTO/IQBOSyncInvoicesUpdateDTO";
import QboInvoicesSyncStatus from "../QboPullInvoicesAsOrdersModal/QboInvoicesSyncStatus";
import * as _ from "lodash-es";
import moment from "moment";
import { Moment } from "moment-timezone";
import queryString from "query-string";
import React, { Component } from "react";
import { FormattedMessage, IntlShape } from "react-intl";
import Modal from "react-modal";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";
import quickBooksIcon from "../../../assets/images/quickbooks/QB_16x16.png";
import taxJarLogoDarkOpacity50 from "../../../assets/images/taxjar/taxjar-glyph-dark-opacity-50.svg";
import taxJarLogoOpacity50 from "../../../assets/images/taxjar/taxjar-glyph-opacity-50.svg";
import taxJarLightLogo from "../../../assets/images/taxjar/taxjar-glyph.svg";
import xeroLogo from "../../../assets/images/xero/Logo - Blue.png";
import xeroLogoGrey from "../../../assets/images/xero/Logo - Grey.png";
import AccountingTypesEnum from "../../../models/AccountingTypesEnum";
import IBulkQuoteConvertDTO from "../../../models/DTO/IBulkQuoteConvertDTO";
import ICreateOrderBatchDTO from "../../../models/DTO/ICreateOrderBatchDTO";
import ICreatePickListDTO from "../../../models/DTO/ICreatePickListDTO";
import IDeleteOrderDTO from "../../../models/DTO/IDeleteOrderDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IFishbowlCreateQueueItemDTO from "../../../models/DTO/IFishbowlCreateQueueItemDTO";
import IFishbowlCreateSalesOrdersDTO from "../../../models/DTO/IFishbowlCreateSalesOrdersDTO";
import IFishbowlOnCreateQueueItemDTO from "../../../models/DTO/IFishbowlOnCreateQueueItemDTO";
import IFishbowlOnCreateSalesOrdersDTO from "../../../models/DTO/IFishbowlOnCreateSalesOrdersDTO";
import IFishbowlPullShipmentsDTO from "../../../models/DTO/IFishbowlPullShipmentsDTO";
import IGenerateBulkOrderPdfDTO from "../../../models/DTO/IGenerateBulkOrderPdfDTO";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import IGetOrdersDTO from "../../../models/DTO/IGetOrdersDTO";
import IGetSupplierDTO from "../../../models/DTO/IGetSupplierDTO";
import IMaterialsReportDetailDTO from "../../../models/DTO/IMaterialsReportDetailDTO";
import IOnBulkQuoteConvertDTO from "../../../models/DTO/IOnBulkQuoteConvertDTO";
import IOnCreateOrderBatchDTO from "../../../models/DTO/IOnCreateOrderBatchDTO";
import IOnCreatePickListDTO from "../../../models/DTO/IOnCreatePickListDTO";
import IOnDeleteOrderDTO from "../../../models/DTO/IOnDeleteOrderDTO";
import IOnFishbowlPullShipmentsDTO from "../../../models/DTO/IOnFishbowlPullShipmentsDTO";
import IOnGenerateBulkOrderPdfDTO from "../../../models/DTO/IOnGenerateBulkOrderPdfDTO";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetClientsDTO from "../../../models/DTO/IOnGetClientsDTO";
import IOnGetMaterialsReportDTO from "../../../models/DTO/IOnGetMaterialsReportDTO";
import IOnGetOrderDTO from "../../../models/DTO/IOnGetOrderDTO";
import IOnGetOrdersDTO from "../../../models/DTO/IOnGetOrdersDTO";
import IOnGetOrdersPickListDTO from "../../../models/DTO/IOnGetOrdersPickListDTO";
import IOnProcessAccountingDTO from "../../../models/DTO/IOnProcessAccountingDTO";
import IOnQBDCreateDTO from "../../../models/DTO/IOnQBDCreateDTO";
import IOnQBOPullEstimatesDTO from "../../../models/DTO/IOnQBOPullEstimatesDTO";
import IOnReleaseOrderCommissionDTO from "../../../models/DTO/IOnReleaseOrderCommissionDTO";
import IOnShopifyPullOrdersDTO from "../../../models/DTO/IOnShopifyPullOrdersDTO";
import IOnWooCommercePullOrdersDTO from "../../../models/DTO/IOnWooCommercePullOrdersDTO";
import IOpenCartOnPullOrdersDTO from "../../../models/DTO/IOpenCartOnPullOrdersDTO";
import IOpenCartPullOrdersDTO from "../../../models/DTO/IOpenCartPullOrdersDTO";
import IProcessAccountingDTO from "../../../models/DTO/IProcessAccountingDTO";
import IQBDCreateDTO from "../../../models/DTO/IQBDCreateDTO";
import IQBOPullEstimatesDTO from "../../../models/DTO/IQBOPullEstimatesDTO";
import IReleaseOrderCommissionDTO from "../../../models/DTO/IReleaseOrderCommissionDTO";
import IShopifyPullOrdersDTO from "../../../models/DTO/IShopifyPullOrdersDTO";
import ITaxJarCreateOrdersDTO from "../../../models/DTO/ITaxJarCreateOrdersDTO";
import ITaxJarOnCreateOrdersDTO from "../../../models/DTO/ITaxJarOnCreateOrdersDTO";
import ITaxJarOnUpdateOrdersDTO from "../../../models/DTO/ITaxJarOnUpdateOrdersDTO";
import ITaxJarUpdateOrdersDTO from "../../../models/DTO/ITaxJarUpdateOrdersDTO";
import IWooCommercePullOrdersDTO from "../../../models/DTO/IWooCommercePullOrdersDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import FishbowlQueueTypeEnum from "../../../models/FishbowlQueueTypeEnum";
import RestEndpointsEnum from "../../../models/RestEndpointsEnum";
import IAction from "../../../models/IAction";
import ICatalog from "../../../models/ICatalog";
import { ICheckBoxChecked } from "../../../models/ICheckBoxChecked";
import IColumns from "../../../models/IColumns";
import INotification from "../../../models/INotification";
import IOfflineOrder from "../../../models/IOfflineOrder";
import IOrder from "../../../models/IOrder";
import IOrdersViewRowConfig from "../../../models/IOrdersViewRowConfig";
import IOrderUI from "../../../models/IOrderUI";
import IOwTableCols from "../../../models/IOwTableCols";
import IPick_List from "../../../models/IPick_List";
import IProcessedItemsDetails from "../../../models/IProcessedItemsDetails";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import NotificationDismissibleEnum from "../../../models/NotificationDismissibleEnum";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OrderStatesEnum from "../../../models/OrderStatesEnum";
import OrdersViewColEnum from "../../../models/OrdersViewColEnum";
import QBDResourceTypesEnum from "../../../models/QBDResourceTypesEnum";
import SortOrderEnum from "../../../models/SortOrderEnum";
import UserTypesEnum from "../../../models/UserTypesEnum";
import IdbService from "../../../services/IdbService";
import { buildAuthHeadersForFetch, buildRestUrl, buildRestUrlWithQuery } from "../../../services/RestService";
import UIService from "../../../services/UIService";
import UserService from "../../../services/UserService";
import ExportDetail from "../../shared/ExportDetail/ExportDetail";
import OwActionBar from "../../shared/OwActionBar/OwActionBar";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwPrintButton from "../../shared/OwPrintButton/OwPrintButton";
import OwProcessedItemsDetails from "../../shared/OwProcessedItemsDetails/OwProcessedItemsDetails";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import BulkOrderModal from "../BulkOrderModal/BulkOrderModal";
import BulkOrderSubmitModal from "../BulkOrderSubmitModal/BulkOrderSubmitModal";
import { DeallocateInventoryModal } from "../../order_entry/DeallocateInventoryModal/DeallocateInventoryModal";
import IOnDeallocateInventoryDTO from "../../../models/DTO/IOnDeallocateInventoryDTO";
import { CopyToDiffCatalogModal } from "../CopyToDiffCatalogModal/CopyToDiffCatalogModal";
import ExportSidebar from "../ExportSidebar/ExportSidebar";
import { OrderDetailView } from "../OrderDetailView/OrderDetailView";
import PickListExistsModal from "../PickListExistsModal/PickListExistsModal";
import CreateOrderSidebar from "./CreateOrderSidebar/CreateOrderSidebar";
import OrderFilter from "./OrderFilter/OrderFilter";
import { OrdersFilterBar } from "./OrdersFilterBar/OrdersFilterBar";
import { FilterBarVersionToggle } from "../../shared/FilterBarVersionToggle/FilterBarVersionToggle";
import { getFilterBarMode } from "@utils/filterBarVersion";
import "./Orders.scss";
import StandardOfflineOrder from "./OrderTypes/StandardOfflineOrder/StandardOfflineOrder";
import { OrderMetadataSidebar } from "../OrderMetadataSidebar/OrderMetadataSidebar";
import SupplierService from "../../../services/SupplierService";
import { WayfairPurchaseOrderModal } from "./WayfairPurchaseOrderModal/WayfairPurchaseOrderModal";
import { SpsCommerceFilterTransactionsModal } from "./SpsCommerceFilterTransactionsModal/SpsCommerceFilterTransactionsModal";
import { SpsCommerceReceiveOrdersModal } from "./SpsCommerceReceiveOrdersModal/SpsCommerceReceiveOrdersModal";
import IQBOQueueCreateInvoicesDTO from "../../../models/DTO/IQBOQueueCreateInvoicesDTO";
import IQBOOnQueueCreateInvoicesDTO from "../../../models/DTO/IQBOOnQueueCreateInvoicesDTO";
import IZoeyPullOrdersDTO from "../../../models/DTO/IZoeyPullOrdersDTO";
import { QboPullEstimatesModal } from "../QboPullEstimatesModal/QboPullEstimatesModal";
import { ShopifySelectShopModal } from "../../shared/ShopifySelectShopModal/ShopifySelectShopModal";
import IBigCommerceOnPullOrdersDTO from "../../../models/DTO/IBigCommerceOnPullOrdersDTO";
import IBigCommercePullOrdersDTO from "../../../models/DTO/IBigCommercePullOrdersDTO";
import IOnCreateOrderDTO from "../../../models/DTO/IOnCreateOrderDTO";
import SupplierGuidEnum from "../../../models/SupplierGuidEnum";
import { CreateOrderFnSidebar } from "./CreateOrderFnSidebar/CreateOrderFnSidebar";
import OwToggle from "../../shared/OwToggle/OwToggle";
import { Socket } from "socket.io-client";
import ExcelJS from "exceljs";
import IOrder_Progress_State from "../../../models/IOrder_Progress_State";
import ShipmentPackageSidebar from "../../shipments/ShipmentPackageSidebar/ShipmentPackageSidebar";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import IQBOPullInvoicesAsOrdersDTO from "../../../models/QuickBooks Online/IQBOPullInvoicesAsOrdersDTO";
import IQBOOnPullInvoicesAsOrdersDTO from "../../../models/QuickBooks Online/IQBOOnPullInvoicesAsOrdersDTO";
import { QboPullInvoicesAsOrdersModal } from "../QboPullInvoicesAsOrdersModal/QboPullInvoicesAsOrdersModal";
import IQBOBackfillInvoicePaidStatusDTO from "../../../models/QuickBooks Online/IQBOBackfillInvoicePaidStatusDTO";
import IQBOOnBackfillInvoicePaidStatusDTO from "../../../models/QuickBooks Online/IQBOOnBackfillInvoicePaidStatusDTO";
import {
    QboBackfillInvoicePaidStatusModal,
    QboBackfillInvoicePaidStatusOptions,
} from "../QboBackfillInvoicePaidStatusModal/QboBackfillInvoicePaidStatusModal";
import { CartCommissionBackfillModal } from "../CartCommissionBackfillModal/CartCommissionBackfillModal";
import { RouteOptimizationModal } from "../../shared/RouteOptimizationModal/RouteOptimizationModal";
import IQBDGetXmlDTO from "../../../models/DTO/IQBDGetXmlDTO";
import IQBDOnGetXmlDTO from "../../../models/DTO/IQBDOnGetXmlDTO";
import IWooCommercePushOrderDTO from "../../../models/DTO/IWooCommercePushOrderDTO";
import IWooCommerceOnPushOrderDTO from "../../../models/DTO/IWooCommerceOnPushOrderDTO";
import OrderEntryService from "../../../services/OrderEntryService";
import UnanetService from "../../../services/UnanetService";
import { FieldsetActions } from "../../shared/FieldsetActions/FieldsetActions";
import IShopifyPushOrderDTO from "../../../models/DTO/IShopifyPushOrderDTO";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import IShopifyOnPushOrderDTO from "../../../models/DTO/IShopifyOnPushOrderDTO";
import { CreateDailyRouteFromOrdersSidebar } from "../CreateDailyRouteFromOrdersSidebar/CreateDailyRouteFromOrdersSidebar";
import IUpdateTokenSettingsDTO from "../../../models/DTO/IUpdateTokenSettingsDTO";
import IOnUpdateTokenSettingsDTO from "../../../models/DTO/IOnUpdateTokenSettingsDTO";
import { QbdReconcileSalesOrdersModal } from "./QbdReconcileSalesOrdersModal/QbdReconcileSalesOrdersModal";
import IQBDReconcileSalesOrdersDTO from "../../../models/DTO/IQBDReconcileSalesOrdersDTO";
import IQBDOnReconcileSalesOrdersDTO from "../../../models/DTO/IQBDOnReconcileSalesOrdersDTO";
import IFishbowlGetSalesOrdersDataDTO from "../../../models/DTO/IFishbowlGetSalesOrdersDataDTO";
import { Dock } from "react-dock";
import AccessTypesEnum from "../../../models/AccessTypesEnum";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import ICatalog_Item from "../../../models/ICatalog_Item";
import { SearchSection } from "../../shared/SearchSection/SearchSection";
import { OrdersColService } from "./OrdersColService";
import { OrdersService } from "./OrdersService";
import OwBadge from "@components/shared/OwBadge/OwBadge";
import CatalogService from "@services/CatalogService";

type Props = {
    isOnline: boolean;
    socket: Socket;
    history: any;
    location: any;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    intl: IntlShape;
    is_quotes?: boolean;
    is_templates?: boolean;
    userModel: IUserUI;
    vendorModel: IVendorModel;
    supplierModel: ISupplierModel;
    /**
     * @deprecated
     */
    toggleMenu: () => void;
    showHiddenFeatures: boolean;
    isReadOnly: boolean;
    urlPage?: number;
    urlLimit?: number;
    onPaginationUrlChange?: (page: number, limit: number) => void;
};

type State = {
    orders: IOrderUI[];
    offlineOrders: IOfflineOrder[];
    checkBoxChecked: ICheckBoxChecked[];
    clients: any[];
    exportOrders: any[];
    currentView: string;
    hasLocalDelivery: boolean;
    limit: number;
    offset: number;
    totalOrders: any;
    disableCreateOrder: boolean;
    activeCreateOrder: boolean;
    checkAll: boolean;
    hasOneChecked: boolean;
    initialFetch: boolean;
    isDockVisible: boolean;
    dockComponent: any;
    printView: boolean;
    printViewComponent: any;
    queryString?: string;
    navItems?: any;
    actions?: IAction[];
    isSmallTable: boolean;
    numCheckBoxChecked: number;
    columns: IColumns;
    isOnline: boolean;
    hasOfflineOrders: boolean;
    showQbdActions: boolean;
    sourceElementRef: string | null;
    deleteSource: any;
    sortCol: string;
    sortOrder: SortOrderEnum;
    pickListData?: IOnGetOrdersPickListDTO;
    isDataFetching: boolean;
    isInitialData: boolean;
    tableCols: IOwTableCols[];
    showWooCommerceActions: boolean;
    showOpenCartActions: boolean;
    showShopifyActions: boolean;
    showFishbowlActions: boolean;
    createQbdInvoiceActive: boolean;
    createQbdSalesOrdersActive: boolean;
    createQbdInvoiceDisabled: boolean;
    createQbdSalesOrderDisabled: boolean;
    pullQboEstimatesActive: boolean;
    modalComponent: any;
    modalIsOpen: boolean;
    bulkOrderSubmitActive: boolean;
    shopifyPullOrdersActive: boolean;
    shopifyPushOrdersActive: boolean;
    bulkConvertQuotesActive: boolean;
    taxJarBtnActive: boolean;
    taxJarUpdateBtnDisabled: boolean;
    fishbowlBtnActive: boolean;
    createAccountingDetailActive: boolean;
    processedItemsDetails: IProcessedItemsDetails | null;
    queryStringArr: string[];
    selectAll: boolean;
    catalogs: ICatalog[];
    wayfairBtnActive: boolean;
    spsActive: boolean;
    qboActive: boolean;
    qboBulkInvoicePdfActive: boolean;
    routePickListActive: boolean;
    qboInvoiceSyncProgress?: IQBOSyncInvoicesUpdateDTO | null;
    isPickListActive: boolean;
    zoeyActive: boolean;
    bigCommerceActive: boolean;
    newCreateOrderSidebar: boolean;
    stepBeforeShippedOrderStateId?: OrderStatesEnum;
    doCurrencyConversion: boolean;
    useSequelize: boolean;
    isSearchSectionVisible: boolean;
    tokenLimit?: number;
    currentTokenGuid?: string;
};

export class Orders extends Component<Props, State> {
    /** Mirrors QuickbooksOnlineService.BULK_INVOICE_PDF_MAX_ORDERS on the API (POST /qbo/invoices/bulk-pdf). */
    static readonly QBO_BULK_INVOICE_PDF_MAX_ORDERS = 50;
    /** Mirrors OrderSocketController.BULK_DOCUMENTS_MAX_ORDERS on the API (socket getOrdersDocuments). */
    static readonly BULK_DOCUMENTS_MAX_ORDERS = 50;
    /** Mirrors ROUTE_PICK_LIST_MAX_ORDERS on the API (POST /v1/routes/pick-list-export). */
    static readonly ROUTE_PICK_LIST_MAX_ORDERS = 200;

    overlayRow: any;
    _notificationSystem: any = null;
    hasLocalDelivery = false;
    assignOverlayRef: any;

    deleteIndex?: number;

    sockets: IUiSocketSetup[] = [];

    idbService: IdbService = new IdbService();

    constructor(props: any) {
        super(props);

        const title = this.props.is_quotes
            ? "Orderwerks >> Quotes"
            : "Orderwerks >> " + _.startCase(SupplierService.updateStringWithOrderNameOverride("orders", this.props.supplierModel));

        window.addEventListener("online", this.setOnlineStatus);
        window.addEventListener("offline", this.setOnlineStatus);

        document.title = title;

        const hidePricing = UserService.hidePricing(this.props.supplierModel, this.props.userModel, this.props.vendorModel);

        const currentToken = UserService.getCurrentToken(this.props.userModel);

        const userCols = currentToken?.settings?.orders_cols || {};

        // console.log("userCols", userCols);

        const getColumnChecked = (objProp: string, defaultVal: boolean) => {
            let isChecked = defaultVal;

            if (!_.isNil(userCols) && !_.isNil(userCols[objProp])) {
                isChecked = userCols[objProp];
            }

            // console.log("getColumnChecked: ", objProp, isChecked, userCols[objProp]);

            return isChecked;
        };

        const columns: IColumns = {
            name: { name: "vendor", label: "vendor", isChecked: getColumnChecked("vendor", true) },
            priority: {
                name: "priority",
                label: "priority",
                isChecked: getColumnChecked("priority", true),
                notVisible: !this.props.supplierModel.has_vendor_priority || !this.props.userModel.isSupplierUser,
            },
            client_name: {
                name: "client",
                label: "client",
                isChecked: getColumnChecked("client_name", true),
                notVisible: !this.props.supplierModel.has_client_module,
            },
            catalog: { name: "catalog", label: "catalog", isChecked: getColumnChecked("catalog", false) },
            order: {
                name: SupplierService.updateStringWithOrderNameOverride("order_name", this.props.supplierModel),
                label: "order",
                isChecked: getColumnChecked("order", true),
            },
            order_categories: {
                name: "order_categories",
                label: "order_categories",
                isChecked: getColumnChecked("order_categories", false),
                notVisible: !this.props.supplierModel.has_order_categories,
            },
            percFillable: {
                name: "perc_fillable",
                label: "percentage_fillable",
                isChecked: getColumnChecked("percFillable", true),
                notVisible: !this.props.userModel.isSupplierUser || !this.props.supplierModel.has_percent_fillable,
            },
            route: {
                name: "route",
                label: "route",
                isChecked: getColumnChecked("route", true),
                notVisible: !this.props.supplierModel.has_routes,
            },
            sales_rep: {
                name: "sales_rep",
                label: "sales_rep",
                isChecked: getColumnChecked("sales_rep", true),
                notVisible: !this.props.supplierModel.has_rep_groups,
            },
            workflow: {
                name: "workflow",
                label: "workflow",
                isChecked: getColumnChecked("workflow", true),
                notVisible:
                    !this.props.supplierModel.has_multi_workflows ||
                    (!this.props.userModel.isSupplierUser && this.props.userModel.supplierUserToken?.id !== UserTypesEnum.ADMIN),
            },
            total: {
                name: "total",
                label: "total",
                isChecked: getColumnChecked("total", true),
                notVisible: hidePricing,
            },
            price_group: {
                name: "price_group",
                label: "price_group",
                isChecked: getColumnChecked("price_group", true),
                notVisible: !this.props.supplierModel.hide_vendor_price_group_select && !this.props.userModel.isSupplierUser,
            },
            user: { name: "user", label: "user", isChecked: getColumnChecked("user", true) },
            status: {
                name: "status",
                label: "status",
                isChecked: getColumnChecked("status", !this.props.is_templates),
                notVisible: !!this.props.is_templates,
            },
            warehouse: {
                name: "warehouse",
                label: "warehouse",
                isChecked: getColumnChecked("warehouse", true),
                notVisible: !this.props.supplierModel.has_warehouses,
            },
            description: { name: "description", label: "description", isChecked: getColumnChecked("description", true) },
            po_no: { name: "po_no", label: "po_no", isChecked: getColumnChecked("po_no", true) },
            exp_date: {
                name: "exp_date",
                label: "exp_date",
                isChecked: getColumnChecked("exp_date", !!this.props.is_quotes),
                notVisible: !this.props.supplierModel.has_quote_exp,
            },
            local_delivery: {
                name: "local_delivery",
                label: "local_delivery",
                isChecked: getColumnChecked("local_delivery", false),
                notVisible: true,
            },
            due_date: {
                name: "due_date",
                label: "due_date",
                isChecked: getColumnChecked("due_date", true),
                notVisible: !this.props.supplierModel.has_order_due_date,
            },
            ship_date: {
                name: "ship_date",
                label: "ship_date",
                isChecked: getColumnChecked("ship_date", false),
                notVisible: !this.props.supplierModel.Supplier_Integration?.has_zoey,
            },
            do_not_ship_before_date: {
                name: "do_not_ship_before_date",
                label: "do_not_ship_before_date",
                isChecked: getColumnChecked("do_not_ship_before_date", false),
                notVisible: !this.props.supplierModel.has_do_not_ship_before_date,
            },
            delivery_date: {
                name: "delivery_date",
                label: "delivery_date",
                isChecked: getColumnChecked("delivery_date", true),
                notVisible: !this.props.supplierModel.has_delivery_deadlines,
            },
            created_at: { name: "created_at", label: "created_at", isChecked: getColumnChecked("created_at", false) },
            est_ship_date: {
                name: "est_ship_date",
                label: "est_ship_date",
                isChecked: getColumnChecked("est_ship_date", true),
                notVisible: !this.props.supplierModel.has_lead_times,
            },
            last_updated_at: { name: "updated_at", label: "last_updated_at", isChecked: getColumnChecked("last_updated_at", true) },
            // OR-1486: tracker-style optional columns, all off by default; persisted with the rest of orders_cols
            tracking: {
                name: "tracking",
                label: "tracking_no",
                isChecked: getColumnChecked("tracking", false),
                notVisible: !!this.props.is_quotes || !!this.props.is_templates,
            },
            paid: {
                name: "paid",
                label: "paid",
                isChecked: getColumnChecked("paid", false),
                notVisible: !!this.props.is_quotes || !!this.props.is_templates,
            },
            shipping_instructions: {
                name: "shipping_instructions",
                label: "shipping_instructions",
                isChecked: getColumnChecked("shipping_instructions", false),
            },
            internal_note: {
                name: "internal_note",
                label: "internal_note",
                isChecked: getColumnChecked("internal_note", false),
                notVisible: !this.props.userModel.isSupplierUser,
            },
            actions: { name: "actions", label: "", isChecked: getColumnChecked("actions", true), notVisible: true },
        };

        if (this.props.supplierModel.Supplier_Integration.has_unanet) {
            columns.unanet_sync = {
                name: "unanet_sync",
                label: "unanet_sync",
                isChecked: getColumnChecked("unanet_sync", true),
            };
        }

        const tokenLimit =
            currentToken?.settings?.orders_page_size || (this.props.supplierModel.guid === SupplierGuidEnum.VERMONT ? 100 : 25);
        const currentTokenGuid = currentToken?.guid;

        const initialLimit = this.props.urlLimit || tokenLimit;
        const initialOffset = this.props.urlPage ? this.props.urlPage - 1 : 0;

        this.state = {
            orders: [],
            offlineOrders: [],
            checkBoxChecked: [],
            clients: [],
            exportOrders: [],
            // userModel: undefined,
            currentView: "vendor",
            hasLocalDelivery: false,
            limit: initialLimit,
            offset: initialOffset,
            totalOrders: null,
            disableCreateOrder: false,
            activeCreateOrder: false,
            checkAll: false,
            hasOneChecked: false,
            initialFetch: true,
            isDockVisible: false,
            dockComponent: null,
            printView: false,
            printViewComponent: null,
            isSmallTable: true,
            numCheckBoxChecked: 0,
            columns,
            actions: [],
            isOnline: this.props.isOnline,
            hasOfflineOrders: false,
            showQbdActions: this.props.supplierModel.Supplier_Integration
                ? this.props.supplierModel.Supplier_Integration?.has_qbd || false
                : false,
            showWooCommerceActions: this.props.supplierModel.Supplier_Integration
                ? this.props.supplierModel.Supplier_Integration?.has_woocommerce || false
                : false,
            showOpenCartActions: this.props.supplierModel.Supplier_Integration
                ? this.props.supplierModel.Supplier_Integration?.has_opencart || false
                : false,
            showShopifyActions: this.props.supplierModel.Supplier_Integration
                ? this.props.supplierModel.Supplier_Integration?.has_shopify || false
                : false,
            showFishbowlActions: this.props.supplierModel.Supplier_Integration
                ? this.props.supplierModel.Supplier_Integration?.has_fishbowl || false
                : false,
            sourceElementRef: null,
            deleteSource: null,
            sortCol: currentToken?.settings?.orders_sort_col || "updated_at",
            sortOrder: currentToken?.settings?.orders_sort_dir || SortOrderEnum.DESC,
            isDataFetching: false,
            isInitialData: true,
            tableCols: [],
            createQbdSalesOrderDisabled: true,
            createQbdInvoiceDisabled: true,
            createQbdInvoiceActive: false,
            createQbdSalesOrdersActive: false,
            modalIsOpen: false,
            modalComponent: null,
            bulkOrderSubmitActive: false,
            shopifyPullOrdersActive: false,
            shopifyPushOrdersActive: false,
            pullQboEstimatesActive: false,
            bulkConvertQuotesActive: false,
            fishbowlBtnActive: false,
            taxJarBtnActive: false,
            taxJarUpdateBtnDisabled: false,
            createAccountingDetailActive: false,
            processedItemsDetails: null,
            queryStringArr: [],
            selectAll: false,
            catalogs: [],
            wayfairBtnActive: false,
            spsActive: false,
            qboActive: false,
            qboBulkInvoicePdfActive: false,
            routePickListActive: false,
            qboInvoiceSyncProgress: undefined,
            isPickListActive: false,
            zoeyActive: false,
            bigCommerceActive: false,
            newCreateOrderSidebar: false,
            stepBeforeShippedOrderStateId: this.getStepBeforeShippedOrderStateId(),
            doCurrencyConversion: !!this.props.supplierModel.has_currencies,
            useSequelize: false,
            isSearchSectionVisible: true,
            tokenLimit,
            currentTokenGuid,
        };

        this.sockets = [
            { endpoint: EndpointsEnum.OrderOnGetOrders, fn: this.onGetOrders },
            { endpoint: EndpointsEnum.OrderOnGetOrder, fn: this.onGetOrder },
            { endpoint: EndpointsEnum.ClientOnGetClients, fn: this.onGetClients },
            { endpoint: EndpointsEnum.OrderOnCreateOrder, fn: this.onCreateOrder },
            { endpoint: EndpointsEnum.OrderOnDeleteOrder, fn: this.onDeleteOrder },
            { endpoint: EndpointsEnum.ExportOnCreateExport, fn: this.onCreateExport },
            // {endpoint: EndpointsEnum.OrderOnGetOrdersPickList, fn: this.onGetOrdersPickList},
            { endpoint: EndpointsEnum.OrderOnReleaseOrderCommission, fn: this.onReleaseOrderCommission },
            { endpoint: EndpointsEnum.QBDOnCreate, fn: this.onQBDCreate },
            { endpoint: EndpointsEnum.MaterialOnGetMaterialsReport, fn: this.onGetMaterialsReport },
            { endpoint: EndpointsEnum.OrderOnCreatePickList, fn: this.onCreatePickList },
            { endpoint: EndpointsEnum.WooCommerceOnPullOrders, fn: this.onWooCommercePullOrders },
            { endpoint: EndpointsEnum.ShopifyOnPullOrders, fn: this.onShopifyPullOrders },
            { endpoint: EndpointsEnum.QBOOnPullEstimates, fn: this.onPullQboEstimates },
            { endpoint: EndpointsEnum.OrderEntryOnBulkQuoteConvert, fn: this.onBulkConvertQuotesToOrders },
            { endpoint: EndpointsEnum.FishbowlOnCreateSalesOrders, fn: this.onCreateFishbowlSalesOrders },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.OpenCartOnPullOrders, fn: this.onPullOpenCartOrders },
            { endpoint: EndpointsEnum.OrderOnCreateOrderBatch, fn: this.onCreateOrderBatch },
            { endpoint: EndpointsEnum.TaxJarOnCreateOrders, fn: this.onCreateTaxJarOrders },
            { endpoint: EndpointsEnum.TaxJarOnUpdateOrders, fn: this.onUpdateTaxJarOrders },
            { endpoint: EndpointsEnum.AccountingOnProcessAccounting, fn: this.onProcessAccounting },
            { endpoint: EndpointsEnum.Connected, fn: this.onConnect },
            { endpoint: EndpointsEnum.FishbowlOnPullShipments, fn: this.onPullFishbowlShipments },
            { endpoint: EndpointsEnum.FishbowlOnCreateQueueItem, fn: this.onFishbowlCreateQueueItem },
            { endpoint: EndpointsEnum.TokenOnUpdateSettings, fn: this.onUpdateTokenSettings },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: this.onGetCatalogs },
            { endpoint: EndpointsEnum.OrderOnGenerateBulkOrderPDF, fn: this.onCreateBulkPdf },
            { endpoint: EndpointsEnum.QBOOnQueueCreateInvoices, fn: this.onQboCreateInvoices },
            { endpoint: EndpointsEnum.ZoeyOnPullOrders, fn: this.onZoeyPullOrders },
            { endpoint: EndpointsEnum.BigCommerceOnPullOrders, fn: this.onBigCommercePullOrders },
            { endpoint: EndpointsEnum.QBOSyncInvoicesUpdate, fn: this.onQboSyncInvoicesUpdate },
            { endpoint: EndpointsEnum.QBOOnPullInvoicesAsOrders, fn: this.onQboPullInvoicesAsOrders },
            { endpoint: EndpointsEnum.QBOOnBackfillInvoicePaidStatus, fn: this.onQboBackfillInvoicePaidStatus },
            { endpoint: EndpointsEnum.QBDOnGetXML, fn: this.onGetQbdXmlData },
            { endpoint: EndpointsEnum.WooCommerceOnPushOrder, fn: this.onPushWooCommerceOrders },
            { endpoint: EndpointsEnum.ShopifyOnPushOrder, fn: this.onShopifyPushOrders },
            { endpoint: EndpointsEnum.QBDOnReconcileSalesOrders, fn: this.onReconcileSalesOrders },
            { endpoint: EndpointsEnum.FishbowlOnDownloadSalesOrderData, fn: this.onGetFishbowlSalesOrdersData },
        ];
    }

    async componentDidMount() {
        try {
            this.setupSockets();

            // const offlineMode$ = UIService.offlineModeSubject$().subscribe((isOnline) => {
            //     let getOrders = false;
            //
            //     if (!this.state.isOnline && isOnline) {
            //         getOrders = true;
            //     }
            //
            //     this.setState(
            //         {
            //             isOnline,
            //         },
            //         () => {
            //             if (getOrders) {
            //                 this.getOrders("componentDidMount 1");
            //             }
            //         }
            //     );
            // });

            const navItems = [{ title: "Dashboard", url: "/dashboard" }];

            if (this.props.is_quotes) {
                navItems.push({ title: "Quotes", url: "/quotes" });
            } else if (this.props.is_templates) {
                navItems.push({ title: "Templates", url: "/templates" });
            } else {
                navItems.push({
                    title: SupplierService.updateStringWithOrderNameOverride("Orders", this.props.supplierModel),
                    url: SupplierService.updateStringWithOrderNameOverride("/orders", this.props.supplierModel),
                });
            }

            const columns = this.state.columns;

            if (this.props.supplierModel.vendor_name_override) {
                columns.name.label = this.props.supplierModel.vendor_name_override;
                columns.name.name = this.props.supplierModel.vendor_name_override;
            }

            if (!this.props.userModel.isSupplierUser) {
                columns.name.isChecked = false;
                columns.name.notVisible = true;

                columns.est_ship_date.isChecked = false;
                columns.est_ship_date.notVisible = true;

                columns.user.isChecked = false;
                columns.user.notVisible = true;
            }

            let tableCols: IOwTableCols[] = [];

            const currentToken = UserService.getCurrentToken(this.props.userModel);

            const userCols = currentToken?.settings?.orders_cols || {};

            if (this.props.supplierModel.orders_view_row_config) {
                tableCols = this.getCustomOrderRowsConfig();
            } else {
                tableCols = this.getDefaultOrderRowsConfig();
            }

            const state: State = {
                ...this.state,
                navItems,
                columns,
                tableCols,
                actions: this.getActions(),
                // offlineMode$,
            };

            if (this.props.userModel.isSupplierUser) {
                state.currentView = "supplier";
            }

            const queryStringValues = queryString.parse(this.props.location.search);

            if (queryStringValues.create === "true") {
                this.createNewOrderSidebar();
            }

            this.setState(state, () => {
                // this.getOrders();
                if (!this.state.isOnline || !navigator.onLine) {
                    // TODO load clients for offline mode.
                    // this.getOrders("componentDidMount 2");
                    this.getOrdersRest("componentDidMount 2");
                } else {
                    // Calling this function takes ages on Popmounts data to return 12+s
                    // this.getClients();
                }
            });
        } catch (err) {
            console.log(err);
            // await UserService._clearUserData();

            // TODO update to work for local and production
            // let url = "http://localhost:8080/login.html";
            // window.location = url;
        }
    }

    componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        if (this.state.checkBoxChecked.length !== this.state.orders.length) {
            const checkBoxChecked = _.map(this.state.orders, (order: IOrder) => {
                return {
                    checked: false,
                    orderGuid: order.guid,
                    name: order.name!,
                    qbd_TxnID: order.qbd_TxnID,
                    order_batch_id: order.order_batch_id,
                    order,
                } as ICheckBoxChecked;
            });

            this.setState({
                checkBoxChecked,
                actions: this.getActions(),
            });
        }

        // Actions are cached in state; rebuild them when hidden features are toggled from the console.
        if (this.props.showHiddenFeatures !== prevProps.showHiddenFeatures) {
            this.setState({
                actions: this.getActions(),
            });
        }

        if (this.props.socket.id !== prevProps.socket.id) {
            // TODO why is this here again?
            // this.setupSockets();
            // console.log('Socket ID Check: ', this.props.socket.id, prevProps.socket.id);
            // if (this.state.isOnline) {
            //     this.getOrders();
            // }
        }
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }

        window.removeEventListener("online", this.setOnlineStatus);
        window.removeEventListener("offline", this.setOnlineStatus);

        // if (this.state.offlineMode$) {
        //     this.state.offlineMode$.unsubscribe();
        // }
    }

    selectAllFn = (selectAll: boolean) => {
        this.setState(
            {
                selectAll,
                hasOneChecked: selectAll,
                numCheckBoxChecked: selectAll ? this.state.totalOrders || 0 : 0,
            },
            () => {
                if (selectAll) {
                    const notification: INotification = {
                        message: this.state.totalOrders,
                        title: "selected_all_rows",
                        level: NotificationLevelEnum.success,
                        position: NotificationPositionEnum.bc,
                    };

                    this.props.notifyFn(null, notification);
                } else {
                    const notification: INotification = {
                        message: this.state.totalOrders,
                        title: "unselected_all_rows",
                        level: NotificationLevelEnum.success,
                        position: NotificationPositionEnum.bc,
                    };

                    this.props.notifyFn(null, notification);
                }
            }
        );
    };

    getStepBeforeShippedOrderStateId = (): OrderStatesEnum | undefined => {
        if (this.props.supplierModel.has_shipments) {
            const orderWorkflow = this.props.supplierModel.order_progress_states;

            if (orderWorkflow) {
                let previousWorkflowItem: IOrder_Progress_State | undefined;

                for (const workflowItem of orderWorkflow) {
                    if (workflowItem.order_state_id === OrderStatesEnum.SHIPPED) {
                        break;
                    } else {
                        previousWorkflowItem = workflowItem;
                    }
                }

                return previousWorkflowItem?.order_state_id;
            } else {
                return OrderStatesEnum.COMPLETED;
            }
        } else {
            return undefined;
        }
    };

    getActionsCol = (): IOwTableCols => {
        return {
            hasChevron: true,
            showChevronFn: this.rowHasDetailView,
            isActionsCol: true,
            title: "",
            valueProp: "",
            renderFn: this.actionsRenderFn,
            renderFnEmitsRow: true,
            hasCheckAll: true,
            // TODO - Still WIP
            // hasSelectAll: true,
            // selectAllFn: this.selectAllFn
        };
    };

    getCatalogCol = (): IOwTableCols => {
        return {
            title: "catalog",
            valueProp: "Catalog",
            valueSubProp: "name",
            isChecked: () => {
                return this.state.columns.catalog.isChecked;
            },
            renderFn: this.catalogRenderFn,
            renderFnEmitsRow: true,
            isSortable: true,
            sortOrderFn: () => {
                return this.state.sortOrder;
            },
            sortFn: (sortCol: string, sortOrder: SortOrderEnum) => {
                this.toggleSortDir(sortCol, sortOrder, "catalog");
            },
        };
    };

    getOrderCol = (): IOwTableCols => {
        let title = "order";

        if (this.props.is_quotes) {
            title = "quote";
        } else if (this.props.is_templates) {
            title = "templates";
        } else {
            title = SupplierService.updateStringWithOrderNameOverride(title, this.props.supplierModel);
        }

        return {
            title,
            valueProp: "name",
            isChecked: () => {
                return this.state.columns.order.isChecked;
            },
            renderFn: (row: IOrder) => {
                return OrdersColService.renderOrderNameFn({
                    userModel: this.props.userModel,
                    supplierModel: this.props.supplierModel,
                    getViewOrderUrl: this.getViewOrderUrl,
                    row,
                    openShipmentSidebar: this.openShipmentSidebar,
                    stepBeforeShippedOrderStateId: this.state.stepBeforeShippedOrderStateId,
                });
            },
            renderFnEmitsRow: true,
            isSortable: true,
            sortOrderFn: () => {
                return this.state.sortOrder;
            },
            sortFn: (sortCol: string, sortOrder: SortOrderEnum) => {
                this.toggleSortDir(sortCol, sortOrder, "name");
            },
        };
    };

    getOrderStateCol = (): IOwTableCols => {
        return {
            title: "status",
            valueProp: "Order_State",
            valueSubProp: "name",
            renderFn: this.orderStateRenderFn,
            isChecked: () => {
                return this.state.columns.status.isChecked;
            },
        };
    };

    getQuoteExpDateCol = (): IOwTableCols => {
        return {
            title: "exp_date",
            valueProp: "quote_exp_date",
            renderFn: this.quoteExpDatenRenderFn,
            isChecked: () => {
                return this.state.columns.exp_date.isChecked;
            },
        };
    };

    getVendorCol = (): IOwTableCols => {
        return {
            title: "vendor",
            valueProp: "Vendor",
            valueSubProp: "name",
            renderFn: this.renderVendorName,
            renderFnEmitsRow: true,
            isVendorOverride: true,
            isChecked: () => {
                return this.state.columns.name.isChecked;
            },
            isSortable: true,
            sortOrderFn: () => {
                return this.state.sortOrder;
            },
            sortFn: (sortCol: string, sortOrder: SortOrderEnum) => {
                this.toggleSortDir(sortCol, sortOrder, "Vendor.name");
            },
        };
    };

    getDeliveryDateCol = (): IOwTableCols => {
        return {
            title: "delivery_date",
            valueProp: "delivery_date",
            renderFn: OrdersColService.utcDateRenderFn,
            isChecked: () => {
                return this.state.columns.delivery_date.isChecked;
            },
            notVisible: !this.props.supplierModel.has_delivery_deadlines,
            isSortable: true,
            sortOrderFn: () => {
                return this.state.sortOrder;
            },
            sortFn: this.toggleSortDir,
        };
    };

    getCreatedAtCol = (): IOwTableCols => {
        return {
            title: "created_at",
            valueProp: "created_at",
            renderFn: OrdersColService.dateRenderFn,
            isChecked: () => {
                return this.state.columns.created_at.isChecked;
            },
            isSortable: true,
            sortOrderFn: () => {
                return this.state.sortOrder;
            },
            sortFn: this.toggleSortDir,
        };
    };

    getShipDateCol = (): IOwTableCols => {
        return {
            title: "ship_date",
            valueProp: "ship_date",
            renderFn: OrdersColService.dateRenderFn,
            isChecked: () => {
                return this.state.columns.ship_date.isChecked;
            },
            isSortable: false,
            // sortOrderFn: () => {
            //     return this.state.sortOrder;
            // },
            // sortFn: this.toggleSortDir,
        };
    };

    getDoNotShipBeforeDateCol = (): IOwTableCols => {
        return {
            title: "do_not_ship_before_date",
            valueProp: "do_not_ship_before_date",
            renderFn: OrdersColService.dateRenderFn,
            isChecked: () => {
                return this.state.columns.do_not_ship_before_date.isChecked;
            },
            isSortable: false,
        };
    };

    getOrderCategoriesCol = (): IOwTableCols => {
        return {
            title: "order_category",
            valueProp: "Category",
            renderFn: OrdersColService.renderOrderCategoryFn,
            isChecked: () => {
                return this.state.columns.order_categories.isChecked;
            },
            isSortable: false,
            // sortOrderFn: () => {
            //     return this.state.sortOrder;
            // },
            // sortFn: this.toggleSortDir,
        };
    };

    getWarehouseCol = (): IOwTableCols => {
        return {
            title: "warehouse",
            baseObject: "Shipping_Warehouse",
            valueProp: "name",
            renderFn: OrdersColService.warehouseRenderFn,
            renderFnEmitsRow: true,
            isChecked: () => {
                return this.state.columns.warehouse.isChecked;
            },
            notVisible: !this.props.supplierModel.has_warehouses,
        };
    };

    getWorkflowCol = (): IOwTableCols => {
        return {
            title: "workflow",
            baseObject: "Workflow",
            valueProp: "name",
            renderFn: OrdersColService.workflowRenderFn,
            renderFnEmitsRow: true,
            isChecked: () => {
                return this.state.columns.workflow.isChecked;
            },
            notVisible:
                !this.props.supplierModel.has_multi_workflows ||
                (!this.props.userModel.isSupplierUser && this.props.userModel.supplierUserToken?.id !== UserTypesEnum.ADMIN),
        };
    };

    getUpdatedAtCol = (): IOwTableCols => {
        return {
            title: "updated_at",
            valueProp: "updated_at",
            renderFn: OrdersColService.dateRenderFn,
            isChecked: () => {
                return this.state.columns.last_updated_at.isChecked;
            },
            isSortable: true,
            sortOrderFn: () => {
                return this.state.sortOrder;
            },
            sortFn: this.toggleSortDir,
        };
    };

    getDueDateCol = (): IOwTableCols => {
        return {
            title: "due_date",
            valueProp: "due_date",
            renderFn: OrdersColService.dateRenderFn,
            isChecked: () => {
                return this.state.columns.due_date.isChecked;
            },
            isSortable: true,
            sortOrderFn: () => {
                return this.state.sortOrder;
            },
            sortFn: this.toggleSortDir,
        };
    };

    unanetSyncRenderFn = (row: IOrder) => {
        if (row.unanet_synced_at) {
            return (
                <div>
                    <OwBadge title="synced" bgColor="bg-success" />
                    <div>{row.unanet_journal_entry_key}</div>
                </div>
            );
        } else {
            return <OwBadge title="not_synced" bgColor="bg-secondary" />;
        }
    };

    getUnanetSyncCol = (): IOwTableCols => {
        return {
            title: "unanet_sync",
            valueProp: "Unanet_Sync",
            renderFn: this.unanetSyncRenderFn,
            renderFnEmitsRow: true,
            isChecked: () => {
                return this.state.columns.unanet_sync.isChecked;
            },
        };
    };

    getOtherCol = (configItem: IOrdersViewRowConfig): IOwTableCols => {
        const col: Partial<IOwTableCols> = {};

        col.title = configItem.title!;
        col.valueProp = configItem.valueProp!;

        if (configItem.baseObject) {
            col.baseObject = configItem.baseObject;
        }

        if (configItem.valueSubProp) {
            col.valueSubProp = configItem.valueSubProp;
        }

        return col as IOwTableCols;
    };

    getUserCol = (): IOwTableCols => {
        return {
            title: "user",
            valueProp: "User",
            valueSubProp: "name",
            isChecked: () => {
                return this.state.columns.user.isChecked;
            },
        };
    };

    // getWarehouseCol = (): IOwTableCols | undefined => {
    //     if (this.props.supplierModel.has_warehouses) {
    //         return {
    //             title: "warehouse",
    //             baseObject: "Shipping_Warehouse",
    //             valueProp: "name",
    //             isChecked: () => {
    //                 return this.state.columns.warehouse.isChecked;
    //             }
    //         }
    //     }
    // }

    getCustomOrderRowsConfig = () => {
        const tableCols: IOwTableCols[] = [];

        if (this.props.supplierModel.orders_view_row_config) {
            const customConfig = this.props.supplierModel.orders_view_row_config;

            for (const configItem of customConfig) {
                switch (configItem.col) {
                    case OrdersViewColEnum.ACTIONS:
                        tableCols.push(this.getActionsCol());
                        break;

                    case OrdersViewColEnum.CATALOG:
                        tableCols.push(this.getCatalogCol());
                        break;

                    case OrdersViewColEnum.ORDER:
                        tableCols.push(this.getOrderCol());
                        break;

                    case OrdersViewColEnum.USER:
                        tableCols.push(this.getUserCol());
                        break;

                    case OrdersViewColEnum.DUE_DATE:
                        tableCols.push(this.getDueDateCol());
                        break;

                    case OrdersViewColEnum.UNANET_SYNC:
                        tableCols.push(this.getUnanetSyncCol());
                        break;

                    case OrdersViewColEnum.SHIP_DATE:
                        tableCols.push(this.getShipDateCol());
                        break;

                    case OrdersViewColEnum.DO_NOT_SHIP_BEFORE_DATE:
                        tableCols.push(this.getDoNotShipBeforeDateCol());
                        break;

                    case OrdersViewColEnum.STATE:
                        tableCols.push(this.getOrderStateCol());
                        break;

                    case OrdersViewColEnum.VENDOR:
                        if (this.props.userModel.isSupplierUser) {
                            tableCols.push(this.getVendorCol());
                        }
                        break;

                    case OrdersViewColEnum.CREATED_AT:
                        tableCols.push(this.getCreatedAtCol());
                        break;

                    case OrdersViewColEnum.UPDATED_AT:
                        tableCols.push(this.getUpdatedAtCol());
                        break;

                    case OrdersViewColEnum.OTHER:
                        tableCols.push(this.getOtherCol(configItem));
                        break;

                    case OrdersViewColEnum.ORDER_CATEGORIES:
                        tableCols.push(this.getOrderCategoriesCol());
                        break;
                }
            }
        }

        // OR-1486: the optional tracker columns are user-toggled (off by default), so a supplier's custom column
        // order still applies to its configured columns and the tracker columns follow at the end.
        tableCols.push(...this.getTrackerCols());

        return tableCols;
    };

    /**
     * OR-1486: optional tracker-style columns (Tracking #, Paid, Shipping Instructions, Internal Note). All off by
     * default; the user turns them on from the column picker and they persist via the saved column config.
     */
    getTrackerCols = (): IOwTableCols[] => {
        const isOrdersScreen = !this.props.is_quotes && !this.props.is_templates;
        const tableCols: IOwTableCols[] = [];

        if (isOrdersScreen) {
            tableCols.push({
                title: "tracking_no",
                valueProp: "Shipments",
                renderFn: OrdersColService.trackingRenderFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.tracking.isChecked;
                },
            });

            tableCols.push({
                title: "paid",
                valueProp: "is_paid",
                className: "text-center",
                renderFn: OrdersColService.paidRenderFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.paid.isChecked;
                },
            });
        }

        tableCols.push({
            title: "shipping_instructions",
            valueProp: "shipping_instructions",
            renderFn: OrdersColService.truncatedTextRenderFn,
            isChecked: () => {
                return this.state.columns.shipping_instructions.isChecked;
            },
        });

        if (this.props.userModel.isSupplierUser) {
            tableCols.push({
                title: "internal_note",
                valueProp: "internal_note",
                renderFn: OrdersColService.truncatedTextRenderFn,
                isChecked: () => {
                    return this.state.columns.internal_note.isChecked;
                },
            });
        }

        return tableCols;
    };

    getDefaultOrderRowsConfig = () => {
        const tableCols: IOwTableCols[] = [this.getActionsCol(), this.getCatalogCol(), this.getOrderCol()];

        if (this.props.userModel.isSupplierUser && this.props.supplierModel.has_percent_fillable) {
            tableCols.push({
                title: "perc_fillable",
                valueProp: "percentageFillable",
                renderFn: this.precentageFillable,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.percFillable.isChecked;
                },
            });
        }

        tableCols.push(this.getVendorCol());

        if (this.props.supplierModel.has_vendor_priority && this.props.userModel.isSupplierUser) {
            tableCols.push({
                title: "priority",
                valueProp: "Vendor",
                valueSubProp: "priority",
                isChecked: () => {
                    return this.state.columns.priority.isChecked;
                },
                isSortable: true,
                sortOrderFn: () => {
                    return this.state.sortOrder;
                },
                sortFn: (sortCol: string, sortOrder: SortOrderEnum) => {
                    this.toggleSortDir(sortCol, sortOrder, "Vendor.priority");
                },
            });
        }

        if (this.props.supplierModel.has_client_module) {
            tableCols.push({
                title: "client",
                valueProp: "Client",
                valueSubProp: "name",
                notVisible: !this.props.supplierModel.has_client_module,
                isChecked: () => {
                    return this.state.columns.client_name.isChecked;
                },
            });
        }

        if (this.props.supplierModel.has_rep_groups && this.props.userModel.isSupplierUser) {
            tableCols.push({
                title: "sales_rep",
                valueProp: "Sales_Rep",
                valueSubProp: "name",
                isChecked: () => {
                    return this.state.columns.sales_rep.isChecked;
                },
            });
        }

        if (this.props.supplierModel.has_order_categories) {
            tableCols.push({
                title: "order_category",
                valueProp: "Order_Category",
                valueSubProp: "name",
                renderFn: OrdersColService.renderOrderCategoryFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.order_categories.isChecked;
                },
            });
        }

        if (this.props.supplierModel.has_routes && this.props.userModel.isSupplierUser) {
            tableCols.push({
                title: "route",
                valueProp: "Route",
                valueSubProp: "name",
                isChecked: () => {
                    return this.state.columns.route.isChecked;
                },
            });
        }

        if (!this.props.supplierModel.hide_vendor_price_group_select) {
            tableCols.push({
                title: "price_group",
                valueProp: "Price_Group",
                valueSubProp: "value",
                isChecked: () => {
                    return this.state.columns.price_group.isChecked;
                },
            });
        }

        const hidePricing = UserService.hidePricing(this.props.supplierModel, this.props.userModel, this.props.vendorModel);

        if (!hidePricing) {
            tableCols.splice(2, 0, {
                title: "total",
                valueProp: "grand_total",
                className: "text-center",
                renderFn: this.renderTotal,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.total.isChecked;
                },
                isSortable: true,
                sortOrderFn: () => {
                    return this.state.sortOrder;
                },
                sortFn: (sortCol: string, sortOrder: SortOrderEnum) => {
                    this.toggleSortDir(sortCol, sortOrder, "grand_total");
                },
            });
        }

        const deceasedDateCol = OrdersColService.getDeceasedDateCol({
            is_quotes: this.props.is_quotes,
            supplierModel: this.props.supplierModel,
        });

        const deceasedFirstNameCol = OrdersColService.getDeceasedFirstNameCol({
            is_quotes: this.props.is_quotes,
            supplierModel: this.props.supplierModel,
        });

        const deceasedLastNameCol = OrdersColService.getDeceasedLastNameCol({
            is_quotes: this.props.is_quotes,
            supplierModel: this.props.supplierModel,
        });

        if (deceasedDateCol) {
            tableCols.push(deceasedDateCol);
        }

        if (deceasedFirstNameCol) {
            tableCols.push(deceasedFirstNameCol);
        }

        if (deceasedLastNameCol) {
            tableCols.push(deceasedLastNameCol);
        }

        let showEstShipDateNotVisible = true;

        if (
            (this.props.supplierModel.has_lead_times && this.props.supplierModel.shipping_lead_time) ||
            this.props.supplierModel.has_est_ship_date
        ) {
            showEstShipDateNotVisible = false;
        }

        tableCols.push(
            this.getUserCol(),
            this.getWorkflowCol(),
            {
                title: "status",
                valueProp: "Order_State",
                valueSubProp: "name",
                renderFn: this.orderStateRenderFn,
                isChecked: () => {
                    return this.state.columns.status.isChecked;
                },
            },
            this.getWarehouseCol(),
            {
                title: "description",
                valueProp: "description",
                isChecked: () => {
                    return this.state.columns.description.isChecked;
                },
            },
            {
                title: "po_no",
                valueProp: "po_no",
                isChecked: () => {
                    return this.state.columns.po_no.isChecked;
                },
            },
            ...this.getTrackerCols(),
            this.getDeliveryDateCol(),
            this.getCreatedAtCol(),
            this.getShipDateCol(),
            {
                title: "est_ship_date",
                valueProp: "",
                renderFn: OrdersColService.estimatedShipDateRenderFn,
                renderFnEmitsRow: true,
                isChecked: () => {
                    return this.state.columns.est_ship_date.isChecked;
                },
                notVisible: showEstShipDateNotVisible,
                isSortable: true,
                sortOrderFn: () => {
                    return this.state.sortOrder;
                },
                sortFn: (sortCol: string, sortOrder: SortOrderEnum) => {
                    this.toggleSortDir(sortCol, sortOrder, "estimated_shipping_at");
                },
            },
            this.getQuoteExpDateCol(),
            this.getUpdatedAtCol()
        );

        if (this.props.supplierModel.has_order_due_date) {
            const dueDateCol = this.getDueDateCol();

            tableCols.splice(tableCols.length - 3, 0, dueDateCol);
        }

        if (this.props.supplierModel.Supplier_Integration.has_unanet) {
            tableCols.push(this.getUnanetSyncCol());
        }

        if (this.props.supplierModel.has_do_not_ship_before_date) {
            const doNotShipBeforeDateCol = this.getDoNotShipBeforeDateCol();

            tableCols.splice(tableCols.length - 3, 0, doNotShipBeforeDateCol);
        }

        return tableCols;
    };

    setupSockets = () => {
        const forceOnline = UserService.getForceOnline();

        // console.log('setupSockets', this.state.isOnline, navigator.onLine);
        if ((this.state.isOnline && navigator.onLine) || forceOnline) {
            for (const socket of this.sockets) {
                this.props.socket.on(socket.endpoint, socket.fn);
            }

            this.getCatalogs();
            // if (this.props.userModel.isSupplierUser && this.props.userModel.userType?.id === UserTypesEnum.ADMIN) {
            //     this.props.socket.on(`${this.props.supplierModel.guid}-quickbooks_desktop_events`, this.onQBDEvents);
            // }
        }
    };

    notify = () => {
        this.setState({
            fishbowlBtnActive: false,
            wayfairBtnActive: false,
            zoeyActive: false,
            bigCommerceActive: false,
            isDataFetching: false,
            pullQboEstimatesActive: false,
            qboActive: false,
            qboBulkInvoicePdfActive: false,
            qboInvoiceSyncProgress: undefined,
        });
    };

    showUploadModal = () => {
        const component = (
            <BulkOrderModal
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );

        this.setState({
            modalIsOpen: true,
            modalComponent: component,
        });
    };

    afterOpenModal = () => {};

    closeModal = (refreshData?: boolean) => {
        this.setState(
            {
                modalIsOpen: false,
                modalComponent: null,
            },
            () => {
                if (refreshData) {
                    this.getOrders("closeModal");
                }
            }
        );
    };

    onConnect = () => {
        // console.log('onConnect: ', this.props.socket.id);
        if (this.props.socket.id) {
            // this causes massive events to kick off
            // this.setupSockets();
            // this.getOrders("onConnect");
        }
    };

    onQBDEvents = () => {
        this.getOrders("onQBDEvents");
    };

    setOnlineStatus = () => {
        let hasOfflineOrders = this.state.hasOfflineOrders;
        let orders = this.state.orders;

        const forceOnline = UserService.getForceOnline();

        if (!navigator.onLine && !forceOnline) {
            hasOfflineOrders = false;
            // If we don't set the orders to an empty array, the table header will show with the loading screen  as a
            // tr > td item rather than a full width div.
            orders = [];
        } else {
            if (this.state.offlineOrders.length) {
                hasOfflineOrders = true;
            }
        }

        this.setState(
            {
                isOnline: forceOnline || navigator.onLine,
                hasOfflineOrders,
                orders,
            },
            () => {
                this.setupSockets();
                this.getOrders("setOnlineStatus");

                this.setState({
                    actions: this.getActions(),
                });
            }
        );
    };

    /**
     * Render the Total Order Amount Col
     *
     * @param row
     */
    renderTotal = (row: IOrder) => {
        let grandTotal = row.grand_total || 0;

        let prefix = row?.Catalog?.currency_id ? CatalogService.getCurrencyFromId(row.Catalog.currency_id) : "$";

        if (this.state.doCurrencyConversion) {
            let currency = row?.Catalog?.Currency ? row.Catalog.Currency : undefined;

            if (row.Currency) {
                currency = row.Currency;
            }

            prefix = currency ? OrderEntryService.getCurrencySymbol(currency.name) : prefix;

            if (currency && row?.Catalog?.Currency) {
                grandTotal = OrderEntryService.convertCurrency(grandTotal, row.Catalog?.Currency, currency, row.exchange_rate);
            }
        }

        return (
            <NumericFormat
                value={grandTotal}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={this.props.supplierModel.pricing_precision || 2}
                fixedDecimalScale={true}
                prefix={prefix}
            />
        );
    };

    renderOfflineName = (row: IOfflineOrder) => {
        return <div>Offline Order #{row.offlineId}</div>;
    };

    renderOfflineActionsFn = (row: IOfflineOrder, index: number) => {
        let viewLink = <span className="icon-spacer d-inline-block" style={{ width: "18px" }} />;
        let entryUrl = "";

        if (row.offlineGuid) {
            entryUrl = `/orders/${row.offlineGuid}/entry`;

            if (row.is_quote) {
                entryUrl = `/quotes/${row.offlineGuid}/entry`;
            }

            const name = row.offlineId;

            viewLink = (
                <Link to={entryUrl}>
                    <i className=" d-print-none far fa-eye" title={`${name} Order Entry`} />
                </Link>
            );
        }

        let confirmDeleteAction: any = "";

        const rowRef = document.getElementById(`offline-row-${index}`);

        confirmDeleteAction = (
            <span className={"ms-4"}>
                <i
                    title={"Confirm Delete"}
                    className="far fa-trash-alt pointer d-print-none text-danger"
                    onClick={(e) => {
                        this.toggleConfirmDelete(e, row, index);
                    }}
                />
            </span>
        );

        return (
            <div>
                {viewLink} {confirmDeleteAction}
            </div>
        );
    };

    renderVendorName = (row: IOrder) => {
        let alertIcon = false;
        let alertTitle: any;

        if (
            !row.Vendor?.Vendor_Integration?.qbd_ListID &&
            this.props.supplierModel.Supplier_Integration.has_qbd &&
            this.props.userModel.isSupplierUser
        ) {
            alertIcon = true;
            alertTitle = "Not Connected To QuickBooks Desktop";
        }

        const vendorName = SupplierService.updateStringWithVendorOverride("vendors", this.props.supplierModel);

        return (
            <div>
                <Link to={`/${vendorName}?name=${row.Vendor?.name}&order_by=name&order_dir=asc`}>{row.Vendor?.name}</Link>
                {alertIcon ? (
                    <span className={"d-inline-flex align-items-center justify-content-center"}>
                        <i className={"fas fa-exclamation-triangle text-warning ms-2"} title={alertTitle}></i>
                        <img alt={"QuickBooks Desktop"} src={quickBooksIcon} height={16} title={alertTitle} />
                    </span>
                ) : null}
            </div>
        );
    };

    getViewOrderUrl = (row: IOrder): string => {
        return UIService.getViewOrderUrl(row, this.props.supplierModel);
    };

    catalogRenderFn = (row: IOrder): any => {
        let catalogName = "";

        if (row.Catalog?.name) {
            catalogName = row.Catalog.name;
        }

        return <div>{catalogName}</div>;
    };

    openShipmentSidebar = (row: IOrder) => {
        const shipmentSidebar = (
            <ShipmentPackageSidebar
                cancel={() => {
                    this.cancelSidebar(true);
                }}
                notifyFn={this.props.notifyFn}
                socket={this.props.socket}
                processedFn={() => {}}
                onUpdateFn={() => {}}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                order={row}
            />
        );

        this.props.setSidebarComponent(shipmentSidebar);
        this.props.toggleSidebar(true);
    };

    precentageFillable = (row: IOrder) => {
        return row.percentageFillable ? <div>{row.percentageFillable}</div> : null;
    };

    orderStateRenderFn = (state: string) => {
        if (state === "IN_PRODUCTION") {
            state = "CONFIRMED";
        }

        return _.startCase(state.toLowerCase());
    };

    quoteExpDatenRenderFn = (expDate: string) => {
        if (expDate) {
            return UserService.parseDate(expDate);
        } else {
            return null;
        }
    };

    actionsRenderFn = (data: IOrderUI, index: number) => {
        if (!this.props.supplierModel || !data) {
            return null;
        }

        let releaseCommissionTitle = "Commission Unpaid";

        if (data.release_commission) {
            releaseCommissionTitle = "Commission Paid";
        }

        let qbdSalesOrderTitle = "Sales Order Not Created";

        if (data.qbd_TxnID) {
            qbdSalesOrderTitle = "Sales Order Created";
        }

        let qbdInvoiceTitle = "Invoice Not Created";

        if (data.qbd_Invoice_TxnID) {
            qbdInvoiceTitle = "Invoice Created";
        }

        let isChecked = false;

        if (this.state.checkBoxChecked && this.state.checkBoxChecked[index]) {
            isChecked = this.state.checkBoxChecked[index].checked;
        }

        if (this.state.selectAll) {
            isChecked = true;
        }

        const toUrl = this.getViewOrderUrl(data);

        let taxJarTitle = "No TaxJar Order Created";
        let taxJarIconLogo = taxJarLogoDarkOpacity50;

        if (UIService.isMainViewLight()) {
            taxJarIconLogo = taxJarLogoOpacity50;
        }

        if (data.taxjar_transaction_id) {
            taxJarIconLogo = taxJarLightLogo;
            taxJarTitle = `TaxJar Order Created`;
        }

        return (
            <div className={"order-info-icons"}>
                <span
                    className={
                        !!this.props.supplierModel.disable_vendor_order_entry && !this.props.userModel.isSupplierUser ? "d-none" : ""
                    }>
                    {this.props.userModel.isSupplierUser || this.state.catalogs.length > 1 ? (
                        <OwCheckbox
                            checked={isChecked}
                            className={"me-4 d-print-none pointer"}
                            label={""}
                            skipTranslate={true}
                            name={""}
                            fn={() => {
                                this.toggleCheckBox(data, index);
                            }}
                        />
                    ) : null}
                </span>

                {this.props.supplierModel.has_accounting || this.props.supplierModel.Supplier_Integration.qbo_grouped_invoices ? (
                    <span className={"me-2"}>
                        <i className={"fad fa-abacus " + (data.accounting_invoice_id ? "text-success" : "text-muted")}></i>
                    </span>
                ) : null}

                {this.props.supplierModel.Supplier_Integration.has_taxjar ? (
                    <span className={"me-2"}>
                        <img src={taxJarIconLogo} height={16} title={taxJarTitle} />
                    </span>
                ) : null}

                {this.props.supplierModel.has_commissions ? (
                    <span className={"me-2"}>
                        <i
                            className={"fad fa-money-check-edit-alt " + (data.release_commission ? "text-success" : "text-muted")}
                            title={releaseCommissionTitle}></i>
                    </span>
                ) : null}

                {this.props.supplierModel.has_pick_list_management ? (
                    <span className={"me-2"}>
                        <i
                            className={"fad fad fa-hand-holding-box " + ((data.Pick_Lists || []).length ? "text-success" : "text-muted")}
                            title={"Has Pick Lists?"}></i>
                    </span>
                ) : null}

                <span className={"me-2"}>
                    <i
                        className={"fad fa-conveyor-belt-alt " + (data.order_batch_id ? "text-success" : "text-muted")}
                        title={"Has Order Batch?"}></i>
                </span>

                {this.props.supplierModel.Supplier_Integration.has_fishbowl &&
                this.props.userModel.isSupplierUser &&
                this.props.userModel.userType?.id === UserTypesEnum.ADMIN ? (
                    <span className={"me-2"}>
                        <i
                            className={"fad fa-list-alt " + (data.fishbowl_so_id ? "text-success" : "text-muted")}
                            title={"Fishbowl Sales Order Created"}></i>
                    </span>
                ) : null}

                {this.props.supplierModel.Supplier_Integration &&
                this.props.supplierModel.Supplier_Integration.has_xero &&
                this.props.userModel.isSupplierUser ? (
                    <span>
                        <span className={"me-2"}>
                            {data.xero_invoice_id ? (
                                <img src={xeroLogo} height={24} title={"Xero Invoice Created"} />
                            ) : (
                                <img src={xeroLogoGrey} height={24} title={"Xero Invoice Not Created"} />
                            )}
                        </span>
                    </span>
                ) : null}

                {this.props.supplierModel.Supplier_Integration &&
                this.props.supplierModel.Supplier_Integration.has_qbo &&
                this.props.userModel.isSupplierUser ? (
                    <span>
                        <span className={"me-2"}>
                            <i
                                className={"fad fa-file-invoice-dollar " + (data.qbo_EntityId ? "text-success" : "text-muted")}
                                title={"QuickBooks Online Invoice"}></i>
                        </span>
                        <span className={"me-2"}>
                            <i
                                className={"fad fa-envelope " + (data.qbo_InvoiceSent ? "text-success" : "text-muted")}
                                title={"QuickBooks Online Invoice Emailed"}></i>
                        </span>
                    </span>
                ) : null}

                {this.props.supplierModel.Supplier_Integration &&
                this.props.supplierModel.Supplier_Integration.has_qbd &&
                this.props.userModel.isSupplierUser ? (
                    <span>
                        {this.props.supplierModel.Supplier_Integration.qbd_version !== "pro" ? (
                            <span className={"me-2"}>
                                <i
                                    className={"fad fa-list-alt " + (data.qbd_TxnID ? "text-success" : "text-muted")}
                                    title={qbdSalesOrderTitle}></i>
                            </span>
                        ) : null}
                        <span className={"me-2"}>
                            <i
                                className={"fad fa-file-invoice " + (data.qbd_Invoice_TxnID ? "text-success" : "text-muted")}
                                title={qbdInvoiceTitle}></i>
                        </span>
                    </span>
                ) : null}
                {this.props.supplierModel.has_serials ? (
                    <span className={"me-2"}>
                        <i className={"fad fa-barcode-alt " + (data.has_serial_items ? "text-warning" : "")} title={"Has Serial Item"} />
                    </span>
                ) : null}

                <span className={"me-2"}>
                    <i
                        className={"fad fa-paperclip " + (data?.Attachments?.length ? "text-warning" : "text-muted")}
                        title={"Attachment"}></i>
                </span>

                <span className={"me-2"}>
                    <i className={"fad fa-sticky-note " + (data.note ? "text-warning" : "text-muted")} title={data.note}></i>
                </span>

                <span className="ms-4" />
                <span
                    className={
                        (!!this.props.supplierModel.disable_vendor_order_entry && !this.props.userModel.isSupplierUser) ||
                        this.props.userModel.supplierUserToken?.Access_Type?.id === AccessTypesEnum.READ_ONLY ||
                        this.props.isReadOnly
                            ? "d-none"
                            : ""
                    }>
                    {data.order_state_id === OrderStatesEnum.PRELIMINARY || this.props.userModel.userType?.id === UserTypesEnum.ADMIN ? (
                        <span
                            tabIndex={0}
                            title={`Confirm Delete for ${data.name} Order`}
                            className={data.rowEditMode ? "d-none" : "me-3 d-flex justify-self-center align-self-center"}>
                            <OwDeleteEditActions
                                isEditMode={false}
                                onTrashClickFn={(e) => {
                                    // console.log('toggleConfirmDelete');
                                    this.toggleConfirmDelete(e, data, index);
                                }}
                                onEditClickFn={() => {}}
                                hideEdit={true}
                            />
                        </span>
                    ) : null}
                </span>
                {/* <span className={data.rowEditMode? 'd-none' : ''}><i className="far fa-pencil pointer" onClick={() => { this.props.toggleRowEditMode(data, index); }}></i></span> */}

                {/*<span className={data.rowEditMode ? "me-3" : "d-none"}>*/}
                {/*    <button*/}
                {/*        className={"btn-icon " + (disabledSaveCommit ? "text-muted disabled-pointer" : "text-warning pointer")}*/}
                {/*        disabled={disabledSaveCommit}*/}
                {/*        onClick={() => {*/}
                {/*            this.toggleRowEditMode(data, index, true);*/}
                {/*        }}>*/}
                {/*        <i className="far fa-check" />*/}
                {/*    </button>*/}
                {/*</span>*/}
                <span className={data.rowEditMode ? "" : "d-none"}>
                    <i
                        className="far fa-times pointer"
                        onClick={() => {
                            this.toggleRowEditMode(data, index, false);
                        }}
                    />
                </span>
            </div>
        );
    };

    showDailyRouteSidebar = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const sidebarComponent = <CreateDailyRouteFromOrdersSidebar orders={checkedOrders} cancelFn={this.cancelSidebar} />;

        this.props.setSidebarComponent(sidebarComponent);
        this.props.toggleSidebar(true);
    };

    showMetaDataSidebar = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const sidebarComponent = <OrderMetadataSidebar cancelFn={this.cancelSidebar} orderModel={checkedOrders[0].order} />;

        this.props.setSidebarComponent(sidebarComponent);
        this.props.toggleSidebar(true);
    };

    cancelSidebar = (refreshData?: boolean) => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);

        if (refreshData) {
            this.getOrders("cancelSidebar");
        }
    };

    /**
     * Check all of the checked order rows.
     *
     * If any have an existing sales order created, then don't allow creation.
     */
    isQbdSalesOrderButtonDisabled = (): boolean => {
        if (this.state.numCheckBoxChecked >= 1) {
            let isDisabled = false;

            for (const checkBoxDetail of this.state.checkBoxChecked) {
                if (checkBoxDetail.checked) {
                    for (const order of this.state.orders) {
                        if (order.guid === checkBoxDetail.orderGuid) {
                            if (order.qbd_TxnID) {
                                isDisabled = true;
                            }

                            if (order.order_state_id === OrderStatesEnum.PRELIMINARY) {
                                isDisabled = true;
                            }

                            if (!order.Vendor?.Vendor_Integration?.qbd_ListID) {
                                isDisabled = true;
                            }
                        }
                    }
                }
            }

            return isDisabled;
        } else {
            return true;
        }
    };

    /**
     * @deprecated
     * @returns
     */
    isCreateDailyRouteButtonDisabled = (): boolean => {
        if (this.state.numCheckBoxChecked >= 1) {
            let isDisabled = false;

            for (const checkBoxDetail of this.state.checkBoxChecked) {
                if (checkBoxDetail.checked) {
                    for (const order of this.state.orders) {
                        if (order.guid === checkBoxDetail.orderGuid) {
                            if (!order.route_id) {
                                isDisabled = true;
                            }
                        }
                    }
                }
            }

            return isDisabled;
        } else {
            return true;
        }
    };

    /**
     * If any have an existing invoice created, then don't allow creation
     */
    isQbdInvoiceButtonDisabled = (): boolean => {
        if (this.state.numCheckBoxChecked >= 1) {
            let isDisabled = false;

            for (const checkBoxDetail of this.state.checkBoxChecked) {
                if (checkBoxDetail.checked) {
                    for (const order of this.state.orders) {
                        if (order.guid === checkBoxDetail.orderGuid) {
                            // Already has an Invoice OR Has No Sales Order AND isn't Pro Version
                            if (
                                !_.isNil(order.qbd_Invoice_TxnID) ||
                                (_.isNil(order.qbd_TxnID) &&
                                    this.props.supplierModel.Supplier_Integration.qbd_version !== "pro" &&
                                    !this.props.supplierModel.Supplier_Integration.qbd_allow_straight_invoice)
                            ) {
                                isDisabled = true;
                            }

                            // Not out of Prelim
                            if (order.order_state_id === OrderStatesEnum.PRELIMINARY) {
                                isDisabled = true;
                            }

                            // Not Connected
                            if (!order.Vendor?.Vendor_Integration?.qbd_ListID) {
                                isDisabled = true;
                            }
                        }
                    }
                }
            }

            return isDisabled;
        } else {
            return true;
        }
    };

    spsFilterTransactions = () => {
        const modalComponent = (
            <SpsCommerceFilterTransactionsModal closeModalFn={this.closeModal} socket={this.props.socket} notifyFn={this.props.notifyFn} />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    spsReceiveOrders = () => {
        const modalComponent = (
            <SpsCommerceReceiveOrdersModal closeModalFn={this.closeModal} socket={this.props.socket} notifyFn={this.props.notifyFn} />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    getActions = () => {
        if (this.props.userModel && this.state.isOnline && navigator.onLine) {
            const showCheckBoxes = !!(this.props.userModel.isSupplierUser && _.get(this.props.supplierModel, "has_exports", false));
            const showPickingList = true; // !!(this.props.userModel.isSupplierUser && _.get(this.props.supplierModel, 'shipping_lead_time', false));
            const showPackingList = true; // !(this.props.userModel.isSupplierUser && _.get(this.props.supplierModel, "has_shipments", true));

            const showCreateInvoice = true;

            const actions: IAction[] = [];

            const documentsActions: IAction = {
                name: "documents",
                isDropdownGroup: true,
                groupActions: [],
            };

            // TODO - Update to show for Sales FULL Users
            if (this.props.userModel.isSupplierUser) {
                if (
                    this.props.userModel.guid === "6c672f05-9617-4a7f-962f-79abcc91ecd8" ||
                    this.props.userModel?.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN
                ) {
                    if (!this.props.is_quotes) {
                        const bulkActions: IAction = {
                            name: "bulk_batch",
                            isDropdownGroup: true,
                            groupActions: [],
                        };

                        if (Array.isArray(bulkActions.groupActions)) {
                            bulkActions.groupActions.push({
                                name: SupplierService.updateStringWithOrderNameOverride("bulk_order_submit", this.props.supplierModel),
                                fn: this.bulkOrderSubmit,
                                disabledFn: (e: any) => {
                                    return !this.state.numCheckBoxChecked;
                                },
                                isActive: () => {
                                    return this.state.bulkOrderSubmitActive;
                                },
                            });

                            if (showCheckBoxes) {
                                bulkActions.groupActions.push({
                                    name: "add_to_export",
                                    fn: this.addToExport,
                                    isActive: false,
                                });
                            }

                            bulkActions.groupActions.push({
                                name: "create_batch",
                                fn: this.createOrderBatch,
                                isActive: false,
                                disabledFn: (e: any) => {
                                    return !this.selectedRowsBatchReady();
                                },
                            });

                            if (
                                !!this.state.catalogs.length &&
                                !(this.props.userModel.supplierUserToken?.Access_Type?.id === AccessTypesEnum.READ_ONLY)
                            ) {
                                bulkActions.groupActions.push({
                                    name: "copy_to_diff_catalog",
                                    fn: this.copyOrderToDiffCatalog,
                                    isActive: false,
                                    hasDividerAfter: true,
                                });
                            }

                            if (this.props.supplierModel) {
                                if (this.props.supplierModel.has_commissions) {
                                    bulkActions.groupActions.push({
                                        name: "release_commission",
                                        fn: this.releaseCommissions,
                                        isActive: false,
                                        hasDividerAfter: true,
                                    });
                                }
                            }

                            bulkActions.groupActions.push({
                                name: "deallocate_inventory",
                                fn: this.bulkDeallocateInventory,
                                disabledFn: () => {
                                    return !this.state.numCheckBoxChecked;
                                },
                                isActive: false,
                            });

                            if (
                                this.props.supplierModel.has_accounting ||
                                this.props.supplierModel.Supplier_Integration.qbo_grouped_invoices
                            ) {
                                bulkActions.groupActions.push({
                                    name: "create_grouped_invoice",
                                    fn: this.createAccountingDetail,
                                    isActive: () => {
                                        return this.state.createAccountingDetailActive;
                                    },
                                    disabledFn: this.isAccountingCreateDisabled,
                                });
                            }
                        }

                        actions.push(bulkActions);

                        // if (showCheckBoxes) {

                        // }

                        if (Array.isArray(documentsActions.groupActions)) {
                            documentsActions.groupActions.push({
                                name: "sales_order",
                                fn: this.createSalesOrder,
                                isActive: false,
                                disabledFn: (e: any) => {
                                    return !this.state.numCheckBoxChecked;
                                },
                            });

                            if (showCreateInvoice) {
                                documentsActions.groupActions.push({
                                    name: "invoice",
                                    fn: this.createInvoice,
                                    isActive: false,
                                    disabledFn: (e: any) => {
                                        return !this.state.numCheckBoxChecked;
                                    },
                                });
                            }

                            if (showPickingList) {
                                documentsActions.groupActions.push({
                                    name: "pick_list",
                                    fn: this.createPickList,
                                    isActive: () => {
                                        return this.state.isPickListActive;
                                    },
                                });
                            }

                            // Orders screen only: the enclosing block already excludes quotes; templates are not orders.
                            if (SupplierService.hasRoutePickList(this.props.supplierModel) && !this.props.is_templates) {
                                documentsActions.groupActions.push(this.getExportRoutePickListAction());
                            }

                            if (this.props.supplierModel.has_bill_of_lading) {
                                documentsActions.groupActions.push({
                                    name: "bol",
                                    fn: this.createBillOfLading,
                                    isActive: false,
                                });
                            }

                            if (showPackingList && !this.props.supplierModel.has_pick_list_management) {
                                documentsActions.groupActions.push({
                                    name: "packing_list",
                                    fn: this.createPackingList,
                                    isActive: false,
                                    disabledFn: (e: any) => {
                                        return !this.state.numCheckBoxChecked;
                                    },
                                });
                            }

                            if (this.props.supplierModel.has_bom) {
                                documentsActions.groupActions.push({
                                    name: "materials_report",
                                    fn: this.getMaterialsReport,
                                    isActive: false,
                                });
                            }

                            documentsActions.groupActions.push({
                                name: "order_pdf",
                                fn: this.createBulkPdf,
                                isActive: false,
                            });

                            documentsActions.groupActions.push({
                                name: "download_view_data",
                                fn: this.downloadOrdersScreen,
                                isActive: false,
                                disabledFn: (e: any) => {
                                    return false;
                                },
                            });
                        }

                        actions.push(documentsActions);

                        if (
                            this.props.supplierModel &&
                            SupplierService.isSupplierUserType(this.props.userModel?.supplierUserToken, [
                                UserTypesEnum.ADMIN,
                                UserTypesEnum.ORDER_MGMT,
                                UserTypesEnum.SHIP_MGMT,
                            ])
                        ) {
                            if (this.props.supplierModel.has_routes) {
                                const dailyRouteActions: IAction = {
                                    name: "daily_routes",
                                    isDropdownGroup: true,
                                    disabledFn: () => {
                                        return this.state.numCheckBoxChecked < 1;
                                    },
                                    groupActions: [
                                        {
                                            name: "create_daily_route",
                                            fn: this.showDailyRouteSidebar,
                                            disabledFn: () => {
                                                return this.state.numCheckBoxChecked < 1;
                                            },
                                        },
                                    ],
                                };

                                if (Array.isArray(dailyRouteActions.groupActions)) {
                                    dailyRouteActions.groupActions.push({
                                        name: "get_optimized_route",
                                        fn: this.getOptimizedRoute,
                                        isActive: false,
                                        disabledFn: (e: any) => {
                                            return !this.state.numCheckBoxChecked;
                                        },
                                    });
                                }

                                actions.push(dailyRouteActions);
                            }

                            actions.push({
                                name: "edit_metadata",
                                fn: this.showMetaDataSidebar,
                                disabledFn: () => {
                                    return this.state.numCheckBoxChecked !== 1;
                                },
                            });

                            // if (this.props.supplierModel.Supplier_Integration.has_zoey) {
                            //     actions.push({
                            //         name: "zoey",
                            //         isGroup: true,
                            //         groupActions: [
                            //             {
                            //                 name: "pull_orders",
                            //                 fn: this.zoeyPullOrders,
                            //                 isActive: () => {
                            //                     return this.state.zoeyActive;
                            //                 },
                            //                 disabledFn: () => {
                            //                     return this.state.zoeyActive;
                            //                 },
                            //             },
                            //         ],
                            //     });
                            // }

                            if (SupplierService.isSupplierUserType(this.props.userModel?.supplierUserToken, UserTypesEnum.ADMIN)) {
                                // Only offer the QuickBooks Online dropdown when the supplier is connected to QBO.
                                // `has_qbo` is null for suppliers that never connected, not just false.
                                if (this.props.supplierModel.Supplier_Integration?.has_qbo) {
                                    const qboGroupActions: IAction = {
                                        name: "quickbooks_online",
                                        isDropdownGroup: true,
                                        groupActions: [
                                            {
                                                name: "queue_create_invoices",
                                                fn: this.qboQueueCreateInvoices,
                                                isActive: () => {
                                                    return this.state.qboActive;
                                                },
                                                disabledFn: () => {
                                                    return this.state.qboActive || !this.props.supplierModel.Supplier_Integration.has_qbo;
                                                },
                                            },
                                            {
                                                name: "download_qbo_invoices",
                                                fn: () => this.qboBulkInvoicePdf("download"),
                                                leftIconClass: "fad fa-download",
                                                isActive: () => {
                                                    return this.state.qboBulkInvoicePdfActive;
                                                },
                                                disabledFn: () => {
                                                    return (
                                                        this.state.qboBulkInvoicePdfActive ||
                                                        !this.props.supplierModel.Supplier_Integration.has_qbo
                                                    );
                                                },
                                            },
                                            {
                                                name: "print_qbo_invoices",
                                                fn: () => this.qboBulkInvoicePdf("print"),
                                                leftIconClass: "fad fa-print",
                                                isActive: () => {
                                                    return this.state.qboBulkInvoicePdfActive;
                                                },
                                                disabledFn: () => {
                                                    return (
                                                        this.state.qboBulkInvoicePdfActive ||
                                                        !this.props.supplierModel.Supplier_Integration.has_qbo
                                                    );
                                                },
                                            },
                                            {
                                                name: "pull_invoices_as_orders",
                                                isActive: () => {
                                                    return this.state.qboActive;
                                                },
                                                fn: this.showQboPullInvoicesAsOrdersModal,
                                                leftIconClass: "fad fa-download",
                                                disabledFn: () => {
                                                    return this.state.qboActive;
                                                },
                                            },
                                        ],
                                    };

                                    // Hidden feature: pushed (not d-none) so nothing renders when the flag is off.
                                    if (this.props.showHiddenFeatures) {
                                        qboGroupActions.groupActions!.push({
                                            name: "backfill_qbo_invoice_paid_status",
                                            fn: this.showQboBackfillInvoicePaidStatusModal,
                                            leftIconClass: "fad fa-money-check-alt",
                                            isActive: () => {
                                                return this.state.qboActive;
                                            },
                                            // The tool takes no selection; only one QBO job may run at a time.
                                            disabledFn: () => {
                                                return this.state.qboActive;
                                            },
                                        });
                                    }

                                    actions.push(qboGroupActions);
                                }

                                // Hidden feature: pushed (not d-none) so nothing renders when the flag is off.
                                if (this.props.showHiddenFeatures) {
                                    actions.push({
                                        name: "backfill_cart_commissions",
                                        fn: this.showCartCommissionBackfillModal,
                                        leftIconClass: "fad fa-hand-holding-usd",
                                        // Overrides the action bar's "needs a checked row" default; the tool takes no selection.
                                        disabledFn: () => false,
                                    });
                                }
                            }

                            if (this.props.supplierModel.Supplier_Integration.has_sps) {
                                actions.push({
                                    name: "sps_commerce",
                                    isGroup: true,
                                    groupActions: [
                                        {
                                            name: "filter_transactions",
                                            fn: this.spsFilterTransactions,
                                            isActive: () => {
                                                return this.state.spsActive;
                                            },
                                            disabledFn: () => {
                                                return this.state.spsActive;
                                            },
                                        },
                                        {
                                            name: "receive_orders",
                                            fn: this.spsReceiveOrders,
                                            isActive: () => {
                                                return this.state.spsActive;
                                            },
                                            disabledFn: () => {
                                                return this.state.spsActive;
                                            },
                                        },
                                    ],
                                });
                            }

                            const qbdGroupActions: IAction[] = [];

                            if (this.props.supplierModel.Supplier_Integration.qbd_version !== "pro") {
                                qbdGroupActions.push({
                                    name: "create_sales_orders",
                                    fn: this.createQbdSalesOrders,
                                    isActive: () => {
                                        return this.state.createQbdSalesOrdersActive;
                                    },
                                    disabledFn: this.isQbdSalesOrderButtonDisabled,
                                });
                            }

                            qbdGroupActions.push({
                                name: "create_invoice",
                                fn: this.createQbdInvoices,
                                isActive: () => {
                                    return this.state.createQbdInvoiceActive;
                                },
                                disabledFn: this.isQbdInvoiceButtonDisabled,
                            });

                            qbdGroupActions.push({
                                name: "reconcile_sales_orders",
                                fn: this.showReconcileSalesOrdersModal,
                                isActive: () => {
                                    return this.state.createQbdInvoiceActive;
                                },
                                disabledFn: () => {
                                    return this.state.createQbdInvoiceActive;
                                },
                            });

                            qbdGroupActions.push({
                                name: "get_xml_so_data",
                                isActive: () => {
                                    return this.state.qboActive;
                                },
                                fn: () => {
                                    this.getQbdXmlData("SALES_ORDER");
                                },
                                leftIconClass: "fad fa-download",
                                disabledFn: () => {
                                    return this.state.qboActive;
                                },
                                btnClass: () => {
                                    return this.props.showHiddenFeatures ? "" : "d-none";
                                },
                            });

                            qbdGroupActions.push({
                                name: "get_xml_invoice_data",
                                isActive: () => {
                                    return this.state.qboActive;
                                },
                                fn: () => {
                                    this.getQbdXmlData("INVOICE");
                                },
                                leftIconClass: "fad fa-download",
                                disabledFn: () => {
                                    return this.state.qboActive;
                                },
                                btnClass: () => {
                                    return this.props.showHiddenFeatures ? "" : "d-none";
                                },
                            });

                            if (this.state.showQbdActions) {
                                actions.push({
                                    name: "quickbooks_enterprise",
                                    isDropdownGroup: true,
                                    groupActions: qbdGroupActions,
                                });
                            }
                        }

                        if (this.props.supplierModel && this.props.userModel?.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN) {
                            if (this.props.supplierModel.Supplier_Integration.has_wayfair) {
                                actions.push({
                                    name: "wayfair",
                                    isDropdownGroup: true,
                                    disabledFn: () => {
                                        return false;
                                    },
                                    groupActions: [
                                        {
                                            name: "pull_purchase_orders",
                                            fn: this.wayfairShowPullPurchaseOrdersModal,
                                            disabledFn: () => {
                                                return false;
                                            },
                                        },
                                    ],
                                });
                            }

                            if (this.props.supplierModel.Supplier_Integration.has_bigcommerce) {
                                actions.push({
                                    name: "bigcommerce",
                                    isDropdownGroup: true,
                                    disabledFn: () => {
                                        return false;
                                    },
                                    groupActions: [
                                        {
                                            name: "pull_orders",
                                            fn: this.bigCommercePullOrders,
                                            disabledFn: () => {
                                                return this.state.bigCommerceActive;
                                            },
                                        },
                                    ],
                                });
                            }

                            if (this.state.showWooCommerceActions) {
                                actions.push({
                                    name: "woocommerce",
                                    isDropdownGroup: true,
                                    disabledFn: () => {
                                        return false;
                                    },
                                    groupActions: [
                                        {
                                            name: "pull_orders",
                                            fn: this.pullWooCommerceOrders,
                                            isActive: false,
                                            disabledFn: () => {
                                                return false;
                                            },
                                        },
                                        {
                                            name: "push_orders",
                                            fn: this.pushWooCommerceOrders,
                                            isActive: false,
                                            disabledFn: () => {
                                                return false;
                                            },
                                        },
                                    ],
                                });
                            }

                            if (this.props.supplierModel?.Supplier_Integration?.has_unanet && !this.props.is_quotes) {
                                actions.push({
                                    name: "unanet",
                                    isDropdownGroup: true,
                                    groupActions: [
                                        {
                                            name: "queue_journal_entries",
                                            fn: this.queueUnanetJournalEntries,
                                            isActive: false,
                                            disabledFn: () => !this.state.numCheckBoxChecked,
                                        },
                                    ],
                                });
                            }
                        }

                        if (this.props.supplierModel && this.props.userModel?.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN) {
                            if (this.state.showOpenCartActions) {
                                actions.push({
                                    name: "opencart",
                                    isDropdownGroup: true,
                                    disabledFn: () => {
                                        return false;
                                    },
                                    groupActions: [
                                        {
                                            name: "pull_orders",
                                            fn: this.pullOpenCartOrders,
                                            isActive: false,
                                            disabledFn: () => {
                                                return false;
                                            },
                                        },
                                    ],
                                });
                            }
                        }

                        if (this.props.supplierModel && this.props.userModel?.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN) {
                            if (this.state.showShopifyActions) {
                                actions.push({
                                    name: "shopify",
                                    isDropdownGroup: true,
                                    disabledFn: () => {
                                        return false;
                                    },
                                    groupActions: [
                                        {
                                            name: "pull_orders",
                                            fn: this.shopShopifyShopSelectionModal,
                                            isActive: () => {
                                                return this.state.shopifyPullOrdersActive;
                                            },
                                            disabledFn: () => {
                                                return false;
                                            },
                                        },
                                        {
                                            name: "push_orders",
                                            fn: this.shopifyPushOrders,
                                            isActive: () => {
                                                return this.state.shopifyPushOrdersActive;
                                            },
                                            disabledFn: () => {
                                                return this.state.numCheckBoxChecked < 1;
                                            },
                                        },
                                    ],
                                });
                            }
                        }

                        if (this.props.supplierModel && this.props.userModel?.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN) {
                            if (this.state.showFishbowlActions) {
                                actions.push({
                                    name: "fishbowl",
                                    isDropdownGroup: true,
                                    disabledFn: () => {
                                        return false;
                                    },
                                    groupActions: [
                                        {
                                            name: "queue_create_sales_orders",
                                            fn: this.queueCreateFishbowlSalesOrders,
                                            isActive: () => {
                                                return this.state.fishbowlBtnActive;
                                            },
                                            disabledFn: (e: any) => {
                                                return !this.state.numCheckBoxChecked;
                                            },
                                        },
                                        {
                                            name: "queue_pull_shipments",
                                            fn: this.queuePullFishbowlShipments,
                                            isActive: () => {
                                                return this.state.fishbowlBtnActive;
                                            },
                                            disabledFn: () => {
                                                return false;
                                            },
                                        },
                                        {
                                            name: "get_sales_order_data",
                                            fn: this.getFishbowlSalesOrderData,
                                            isActive: () => {
                                                return this.state.fishbowlBtnActive;
                                            },
                                            disabledFn: () => {
                                                return false;
                                            },
                                            btnClass: () => {
                                                return this.props.showHiddenFeatures ? "" : "d-none";
                                            },
                                        },
                                    ],
                                });
                            }
                        }

                        if (this.props.supplierModel && this.props.userModel?.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN) {
                            if (this.props.supplierModel.Supplier_Integration.has_taxjar) {
                                actions.push({
                                    name: "taxjar",
                                    isDropdownGroup: true,
                                    disabledFn: () => {
                                        return false;
                                    },
                                    groupActions: [
                                        {
                                            name: "submit_orders",
                                            fn: this.createTaxJarOrders,
                                            isActive: () => {
                                                return this.state.taxJarBtnActive;
                                            },
                                            disabledFn: this.taxJarBtnDisabled,
                                        },
                                        {
                                            name: "update_orders",
                                            fn: this.updateTaxJarOrders,
                                            isActive: () => {
                                                return this.state.taxJarBtnActive;
                                            },
                                            disabledFn: this.taxJarUpdateBtnDisabled,
                                        },
                                    ],
                                });
                            }
                        }
                    } else {
                        if (this.props.supplierModel && this.props.userModel?.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN) {
                            actions.push({
                                name: "edit_metadata",
                                fn: this.showMetaDataSidebar,
                                disabledFn: () => {
                                    return this.state.numCheckBoxChecked !== 1;
                                },
                            });
                        }

                        if (this.props.userModel.isSupplierUser) {
                            actions.push({
                                name: "bulk_convert_to_orders",
                                fn: this.bulkConvertQuotesToOrders,
                                isActive: () => {
                                    return this.state.bulkConvertQuotesActive;
                                },
                            });

                            actions.push({
                                name: "download_view_data",
                                fn: this.downloadOrdersScreen,
                                isActive: false,
                                disabledFn: (e: any) => {
                                    return false;
                                },
                            });
                        }

                        if (this.props.supplierModel.Supplier_Integration.has_qbo) {
                            actions.push({
                                name: "quickbooks_online",
                                isDropdownGroup: true,
                                groupActions: [
                                    {
                                        name: "pull_estimates",
                                        fn: this.showQboPullEstimatesModal,
                                        isActive: () => {
                                            return this.state.pullQboEstimatesActive;
                                        },
                                        disabledFn: () => {
                                            return false;
                                        },
                                    },
                                ],
                            });
                        }
                    }
                } else {
                    if (!this.props.is_quotes && !this.props.is_templates) {
                        // Non Admin Supplier Users
                        if (Array.isArray(documentsActions.groupActions)) {
                            documentsActions.groupActions.push({
                                name: "sales_order",
                                fn: this.createSalesOrder,
                                isActive: false,
                                disabledFn: (e: any) => {
                                    return this.state.numCheckBoxChecked !== 1;
                                },
                            });

                            if (Array.isArray(documentsActions.groupActions)) {
                                if (
                                    this.props.userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.INVENTORY_MGMT ||
                                    this.props.userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ORDER_MGMT
                                ) {
                                    if (showPickingList) {
                                        documentsActions.groupActions.push({
                                            name: "pick_list",
                                            fn: this.createPickList,
                                            isActive: false,
                                        });
                                    }

                                    if (showPackingList) {
                                        documentsActions.groupActions.push({
                                            name: "packing_list",
                                            fn: this.createPackingList,
                                            isActive: false,
                                            disabledFn: (e: any) => {
                                                // return this.state.numCheckBoxChecked > 1;
                                                return false;
                                            },
                                        });
                                    }
                                }

                                if (
                                    SupplierService.hasRoutePickList(this.props.supplierModel) &&
                                    SupplierService.isSupplierUserType(this.props.userModel?.supplierUserToken, [
                                        UserTypesEnum.ORDER_MGMT,
                                        UserTypesEnum.SHIP_MGMT,
                                    ])
                                ) {
                                    // The non-admin Documents group above is never added to `actions`, so the
                                    // export goes on the bar directly for these users.
                                    actions.push(this.getExportRoutePickListAction());
                                }
                            }
                        }
                    }
                }
            } else {
                // Vendor User Actions
                if (this.state.catalogs.length > 1) {
                    actions.push({
                        name: "copy_to_diff_catalog",
                        fn: this.copyOrderToDiffCatalog,
                        isActive: false,
                    });
                }
            }

            return actions;
        }
    };

    isAccountingCreateDisabled = (e: any): boolean => {
        const hasCheckedBoxes = !this.state.numCheckBoxChecked;

        const existingRowsWithEntry = false;

        const checkedOrders = this.getCheckedOrdersArr();

        for (const checkedOrder of checkedOrders) {
            if (checkedOrder.order.accounting_invoice_id) {
                // TODO removing for intial rollout
                // existingRowsWithEntry = true;
            }
        }

        return hasCheckedBoxes || existingRowsWithEntry;
    };

    createAccountingDetail = () => {
        const checkedOrders = this.getCheckedOrdersArr();
        let vendorId: number = 0;

        const orderGuids = _.map(
            checkedOrders,
            (order: {
                guid: string;
                name: string;
                qbd_TxnID?: string | undefined;
                order_batch_id?: number | null | undefined;
                order: IOrderUI;
            }) => {
                if (vendorId === 0 && order.order.Vendor?.Vendor_Integration?.qbd_ListID) {
                    vendorId = order.order.vendor_id || 0;
                }
                return order.guid;
            }
        );

        if (!vendorId) {
            vendorId = checkedOrders[0].order.vendor_id!;
        }

        const payload: IProcessAccountingDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            orderGuids,
            accounting: {
                vendor_id: vendorId,
                accounting_type_id: AccountingTypesEnum.INVOICE,
            },
            processOrderGuids: true,
        };

        if (this.state.selectAll) {
            payload.selectAll = this.state.selectAll;
            payload.selectAllQueryString = this.state.queryString;
        }

        this.props.socket.emit(EndpointsEnum.AccountingProcessAccounting, payload);
    };

    onProcessAccounting = (data: IOnProcessAccountingDTO) => {
        const notification: INotification = {
            message: "successfully_processed_accounting",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.getOrders("onProcessAccounting");
    };

    queueUnanetJournalEntries = async () => {
        const checkedOrders = this.getCheckedOrdersArr();
        const orderGuids = _.map(checkedOrders, (order: { guid: string }) => order.guid);

        if (!orderGuids.length) {
            return;
        }

        try {
            const { results } = await UnanetService.queueJournalEntryBulk({ orderGuids }, this.props.userModel, this.props.supplierModel!);

            const successCount = results.filter((r) => r.success).length;
            const failCount = results.length - successCount;

            const notification: INotification = {
                title: "unanet_bulk_queue_complete",
                message: `${successCount} / ${results.length} ${failCount ? `(${failCount} failed)` : ""}`,
                level: failCount ? NotificationLevelEnum.warning : NotificationLevelEnum.success,
                position: NotificationPositionEnum.bc,
                skipMessageTranslate: true,
            };

            this.props.notifyFn(null, notification);
            this.getOrders("queueUnanetJournalEntries");
        } catch (err) {
            this.props.notifyFn(null, {
                message: "unanet_bulk_queue_error",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            });
        }
    };

    createTaxJarOrders = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const orderGuids = _.map(checkedOrders, (order: any) => {
            return order.guid;
        });

        const payload: ITaxJarCreateOrdersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel!.guid,
            orderGuids,
        };

        this.props.socket.emit(EndpointsEnum.TaxJarCreateOrders, payload);
    };

    onCreateTaxJarOrders = (data: ITaxJarOnCreateOrdersDTO) => {
        const processedItemsDetails: IProcessedItemsDetails = {
            totalProcessed: data.totalOrders,
            totalUpdated: 0,
            totalCreated: data.totalSuccess,
            totalErrored: data.totalErrors,
            errorDetails: data.errorDetails.map((detail) => {
                return {
                    item: detail.order,
                    error: detail.message,
                };
            }),
        };

        this.setState(
            {
                processedItemsDetails,
            },
            () => {
                this.getOrders("onCreateTaxJarOrders");
            }
        );
    };

    copyOrderToDiffCatalog = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        let allFromSameCatalog = true;

        if (checkedOrders.length) {
            const catalogId = Number(checkedOrders[0].order.catalog_id);

            for (const detail of checkedOrders) {
                console.log(`${detail.order.catalog_id} !== ${catalogId}`);
                if (Number(detail.order.catalog_id) !== catalogId) {
                    allFromSameCatalog = false;
                }
            }
        }

        if (allFromSameCatalog) {
            const orders = checkedOrders.map((detail) => {
                return detail.order;
            });

            // show the modal popup, passing the item guids.
            const modalComponent = (
                <CopyToDiffCatalogModal
                    closeModalFn={this.closeModal}
                    socket={this.props.socket}
                    notifyFn={this.props.notifyFn}
                    catalogs={this.state.catalogs}
                    orders={orders}
                    vendorModel={this.props.vendorModel}
                />
            );

            this.setState({
                modalComponent,
                modalIsOpen: true,
            });
        }
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            callMeta: {
                view: "Orders",
                fn: "getCatalogs",
            },
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState({
            catalogs: data.catalogs,
        });
    };

    updateTaxJarOrders = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const orderGuids = _.map(checkedOrders, (order: any) => {
            return order.guid;
        });

        const payload: ITaxJarUpdateOrdersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel!.guid,
            orderGuids,
        };

        this.props.socket.emit(EndpointsEnum.TaxJarUpdateOrders, payload);
    };

    onUpdateTaxJarOrders = (data: ITaxJarOnUpdateOrdersDTO) => {
        const processedItemsDetails: IProcessedItemsDetails = {
            totalProcessed: data.totalOrders,
            totalUpdated: 0,
            totalCreated: data.totalSuccess,
            totalErrored: data.totalErrors,
            errorDetails: data.errorDetails.map((detail) => {
                return {
                    item: detail.order,
                    error: detail.message,
                };
            }),
        };

        this.setState(
            {
                processedItemsDetails,
            },
            () => {
                this.getOrders("onUpdateTaxJarOrders");
            }
        );
    };

    taxJarBtnDisabled = (): boolean => {
        const checkedOrders = this.getCheckedOrdersArr();

        let hasAlreadySubmittedOrders = false;

        if (checkedOrders) {
            for (const checkedOrder of checkedOrders) {
                if (checkedOrder.order.taxjar_transaction_id) {
                    hasAlreadySubmittedOrders = true;
                }
            }
        }

        let hasNoCheckedBoxes = true;

        if (this.state.numCheckBoxChecked >= 1) {
            hasNoCheckedBoxes = false;
        }

        return hasNoCheckedBoxes || hasAlreadySubmittedOrders;
    };

    taxJarUpdateBtnDisabled = (): boolean => {
        const checkedOrders = this.getCheckedOrdersArr();

        let hasOnlyAlreadySubmittedOrders = true;

        if (checkedOrders) {
            for (const checkedOrder of checkedOrders) {
                if (!checkedOrder.order.taxjar_transaction_id) {
                    hasOnlyAlreadySubmittedOrders = false;
                }
            }
        }

        let hasNoCheckedBoxes = true;

        if (this.state.numCheckBoxChecked >= 1) {
            hasNoCheckedBoxes = false;
        }

        return hasNoCheckedBoxes || !hasOnlyAlreadySubmittedOrders;
    };

    selectedRowsBatchReady = (): boolean => {
        const checkedOrders = this.getCheckedOrdersArr();

        let hasNoBatchedAlready = true;

        checkedOrders.every((order) => {
            if (order.order_batch_id) {
                hasNoBatchedAlready = false;
            }
        });

        let hasCheckedBoxes = false;

        if (this.state.numCheckBoxChecked >= 1) {
            hasCheckedBoxes = true;
        }

        return hasCheckedBoxes && hasNoBatchedAlready;
    };

    getMaterialsReport = () => {
        if (this.props.userModel) {
            const checkedOrders = this.getCheckedOrdersArr();

            const orderGuids = _.map(checkedOrders, (order: any) => {
                return order.guid;
            });

            const payload: any = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel!.guid,
                orderGuids,
            };

            this.props.socket.emit(EndpointsEnum.MaterialGetMaterialsReport, payload);
        }
    };

    onGetMaterialsReport = (data: IOnGetMaterialsReportDTO) => {
        const rows: { catalogItem: ICatalog_Item; qty: number; materials: { name: string; guid: string; qty: number }[] }[] = [];

        const keys = Object.keys(data.catalogItems);

        for (const key of keys) {
            // @ts-expect-error
            const detail: IMaterialsReportDetailDTO = data.catalogItems[key];

            rows.push({
                catalogItem: detail.catalogItem,
                qty: detail.totalOrdered,
                materials: detail.materials,
            });
        }

        const checkedOrders = this.getCheckedOrdersArr();

        const orderNames = _.map(checkedOrders, (order: any) => {
            return <div>{order.name}</div>;
        });

        let tableClass = "table-dark";

        if (UIService.isMainViewLight()) {
            tableClass = ``;
        }

        const printViewComponent = (
            <div className={"materials-report"}>
                <OwTitle title={"materials_report"} leftIconName={"fad fa-cubes"} />
                <div>
                    <OwLabel title={"orders"} />
                    <br />
                    {orderNames}
                </div>
                <table className={`table ${tableClass}`}>
                    <thead>
                        <tr>
                            <th>
                                <OwLabel title={"catalog_item"} />
                            </th>
                            <th>
                                <OwLabel title={"qty"} />
                            </th>
                            <th>
                                <OwLabel title={"materials"} />
                            </th>
                        </tr>
                    </thead>

                    {rows.map((row) => {
                        const materials = row.materials.map((material: { name: string; guid: string; qty: number }) => {
                            const materialQty = material.qty * row.qty;

                            return (
                                <tbody key={material.guid}>
                                    <tr>
                                        <td>{material.name}</td>
                                        <td>{materialQty}</td>
                                    </tr>
                                </tbody>
                            );
                        });

                        return (
                            <tbody key={row.catalogItem.guid}>
                                <tr>
                                    <td>{row.catalogItem.name}</td>
                                    <td>{row.qty}</td>
                                    <td>
                                        <table className={`table w-100 table-borderless ${tableClass}`}>
                                            <thead>
                                                <tr>
                                                    <th className={"w-70"}>
                                                        <OwLabel title={"name"} />
                                                    </th>
                                                    <th className={"w-30"}>
                                                        <OwLabel title={"qty"} />
                                                    </th>
                                                </tr>
                                            </thead>
                                            {materials}
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        );
                    })}
                </table>
            </div>
        );

        this.setState(
            {
                printViewComponent,
            },
            () => {
                this.toggleButtonActive("Create Pick List");
                this.togglePrintView();
            }
        );
    };

    createOrderBatch = () => {
        if (this.props.userModel) {
            const checkedOrders = this.getCheckedOrdersArr();

            const orderGuids = _.map(checkedOrders, (order: any) => {
                return order.guid;
            });

            const payload: ICreateOrderBatchDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel!.guid,
                orderGuids,
            };

            this.props.socket.emit(EndpointsEnum.OrderCreateOrderBatch, payload);
        }
    };

    onCreateOrderBatch = (data: IOnCreateOrderBatchDTO) => {
        const notification: INotification = {
            title: "successfully_created_order_batch",
            message: `Batch #${data.orderBatch.batch_no}`,
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.getOrders("onCreateOrderBatch");
    };

    getQbdXmlData = (type: "SALES_ORDER" | "INVOICE") => {
        if (this.props.userModel) {
            const checkedOrders = this.getCheckedOrdersArr();

            const orderGuids = _.map(checkedOrders, (order: any) => {
                return order.guid;
            });

            if (orderGuids.length > 1) {
                window.alert("Only Select 1 Order");
            } else {
                const payload: IQBDGetXmlDTO = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel!.guid,
                    type,
                    typeGuid: orderGuids[0],
                };

                this.props.socket.emit(EndpointsEnum.QBDGetXML, payload);

                console.log("Getting XML Data for Order", orderGuids[0]);
            }
        }
    };

    onGetQbdXmlData = (data: IQBDOnGetXmlDTO) => {
        console.log("onGetQbdXmlData", data);
    };

    showReconcileSalesOrdersModal = () => {
        const modalComponent = <QbdReconcileSalesOrdersModal closeModalFn={this.closeModal} startFn={this.reconcileSalesOrders} />;

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    reconcileSalesOrders = (initPayload: Partial<IQBDReconcileSalesOrdersDTO>) => {
        const payload: IQBDReconcileSalesOrdersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            ...initPayload,
        };

        this.props.socket.emit(EndpointsEnum.QBDReconcileSalesOrders, payload);

        this.setState({
            modalComponent: null,
            modalIsOpen: false,
            createQbdInvoiceActive: true,
        });
    };

    onReconcileSalesOrders = (data: IQBDOnReconcileSalesOrdersDTO) => {
        const notification: INotification = {
            message: "successfully_reconciled_sales_orders",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                createQbdInvoiceActive: false,
            },
            () => {
                this.getOrders("onReconcileSalesOrders");
            }
        );
    };

    createQbdInvoices = () => {
        if (this.props.userModel) {
            const checkedOrders = this.getCheckedOrdersArr();

            const orderGuids = _.map(checkedOrders, (order: any) => {
                return order.guid;
            });

            const payload: IQBDCreateDTO = {
                resource: QBDResourceTypesEnum.INVOICE,
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel!.guid,
                orderGuids,
            };

            this.props.socket.emit(EndpointsEnum.QBDCreate, payload);

            this.setState({
                createQbdInvoiceActive: true,
            });
        }
    };

    isCreateQbdInvoiceEnabled = (): boolean => {
        let isDisabled = false;

        const checkedOrders = this.getCheckedOrdersArr();

        if (checkedOrders) {
            _.each(checkedOrders, (order: any) => {
                if (!order.qbd_TxnID) {
                    isDisabled = true;
                }
            });
        }

        return isDisabled;
    };

    getCheckedOrdersArr = (): { guid: string; name: string; qbd_TxnID?: string; order_batch_id?: number | null; order: IOrderUI }[] => {
        const checkedCheckBoxes = this.state.checkBoxChecked;

        const checkedOrders = _.filter(checkedCheckBoxes, (checkBox) => {
            return checkBox.checked;
        });

        return _.map(checkedOrders, (order) => {
            const orderDetail: any = { guid: order.orderGuid, name: order.name, order_batch_id: order.order_batch_id, order: order.order };

            if (this.state.showQbdActions) {
                // console.log("order.qbd_TxnID", order.qbd_TxnID, order);
                orderDetail.qbd_TxnID = order.qbd_TxnID;
            }

            return orderDetail;
        });
    };

    onWooCommercePullOrders = (data: IOnWooCommercePullOrdersDTO) => {
        // console.log("onWooCommercePullOrders", data);
        const notification: INotification = {
            title: "successfully_pulled_woocommerce_orders",
            message: `Total Orders: ${data.totalOrders}, Total Created: ${data.totalCreated}`,
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
            autoDismiss: 0,
            dismissible: NotificationDismissibleEnum.CLICK,
            skipMessageTranslate: true,
        };

        this.props.notifyFn(null, notification);

        this.getOrders("onWooCommercePullOrders");
    };

    getFishbowlSalesOrderData = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const orderGuids = _.map(checkedOrders, (order: any) => {
            return order.guid;
        });

        const payload: IFishbowlGetSalesOrdersDataDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            orderGuid: orderGuids[0],
        };

        this.props.socket.emit(EndpointsEnum.FishbowlDownloadSalesOrderData, payload);
    };

    onGetFishbowlSalesOrdersData = (data: IFishbowlGetSalesOrdersDataDTO) => {
        console.log("onGetSalesOrdersData", data);
    };

    queuePullFishbowlShipments = () => {
        if (this.props.userModel) {
            const payload: IFishbowlCreateQueueItemDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                type: FishbowlQueueTypeEnum.SHIPMENTS,
                details: null,
            };

            this.props.socket.emit(EndpointsEnum.FishbowlCreateQueueItem, payload);

            this.setState({
                fishbowlBtnActive: true,
            });
        }
    };

    pullFishbowlShipments = () => {
        if (this.props.userModel) {
            const payload: IFishbowlPullShipmentsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
            };

            this.props.socket.emit(EndpointsEnum.FishbowlPullShipments, payload);

            this.setState({
                fishbowlBtnActive: true,
            });
        }
    };

    onPullFishbowlShipments = (data: IOnFishbowlPullShipmentsDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_fishbowl_shipments",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            fishbowlBtnActive: false,
        });
    };

    /**
     * Queueu Create Sales Orders in Fishbowl
     */
    queueCreateFishbowlSalesOrders = () => {
        if (this.props.userModel) {
            const checkedOrders = this.getCheckedOrdersArr();

            const orderGuids = _.map(checkedOrders, (order: any) => {
                return order.guid;
            });

            const payload: IFishbowlCreateQueueItemDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel!.guid,
                type: FishbowlQueueTypeEnum.SALES_ORDERS,
                details: orderGuids,
            };

            this.props.socket.emit(EndpointsEnum.FishbowlCreateQueueItem, payload);

            this.setState({
                fishbowlBtnActive: true,
            });
        }
    };

    onFishbowlCreateQueueItem = (data: IFishbowlOnCreateQueueItemDTO) => {
        const notification: INotification = {
            title: "created_queue_item",
            message: "check_email_once_completed",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            fishbowlBtnActive: false,
        });
    };

    createFishbowlSalesOrders = () => {
        if (this.props.userModel) {
            const checkedOrders = this.getCheckedOrdersArr();

            const filteredOrders = checkedOrders.filter((orderDetail) => {
                return orderDetail.order.order_state_id !== OrderStatesEnum.PRELIMINARY;
            });

            const preliminaryOrders = checkedOrders.filter((orderDetail) => {
                return orderDetail.order.order_state_id === OrderStatesEnum.PRELIMINARY;
            });

            const orderGuids = _.map(filteredOrders, (order) => {
                return order.guid;
            });

            const payload: IFishbowlCreateSalesOrdersDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel!.guid,
                orderGuids,
            };

            this.props.socket.emit(EndpointsEnum.FishbowlCreateSalesOrders, payload);

            if (preliminaryOrders.length) {
                const ordersFiltered = preliminaryOrders.map((detail) => {
                    return detail.name;
                });

                const message = ordersFiltered.join(",");

                const notification: INotification = {
                    title: "filtered_preliminary_orders",
                    message,
                    level: NotificationLevelEnum.info,
                    position: NotificationPositionEnum.bc,
                    skipMessageTranslate: true,
                };

                this.props.notifyFn(null, notification);
            }

            this.setState({
                fishbowlBtnActive: true,
            });
        }
    };

    onCreateFishbowlSalesOrders = (data: IFishbowlOnCreateSalesOrdersDTO) => {
        const notification: INotification = {
            message: `successfully_processed_fishbowl_sales_orders`,
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.getOrders("onCreateFishbowlSalesOrders");

        this.setState({
            fishbowlBtnActive: false,
            processedItemsDetails: {
                totalUpdated: data.totalUpdated,
                totalCreated: data.totalCreated,
                totalErrored: data.totalErrors,
                totalProcessed: data.totalProcessed,
                errorDetails: data.errorDetails,
            },
        });
    };

    shopifyPushOrders = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const orderGuids = _.map(checkedOrders, (order) => {
            return order.guid;
        });

        const payload: IShopifyPushOrderDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel!.guid,
            orderGuids,
        };

        this.props.socket.emit(EndpointsEnum.ShopifyPushOrder, payload);

        this.setState({
            shopifyPushOrdersActive: true,
        });
    };

    onShopifyPushOrders = (data: IShopifyOnPushOrderDTO) => {
        const notification: INotification = {
            message: "successfully_pushed_shopify_orders",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            processedItemsDetails: data,
            shopifyPushOrdersActive: false,
        });
    };

    shopShopifyShopSelectionModal = () => {
        const modalComponent = <ShopifySelectShopModal closeModalFn={this.closeModal} selectedShopFn={this.pullShopifyOrders} />;

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    pullShopifyOrders = (allShops: boolean, shopGuid?: string) => {
        const payload: IShopifyPullOrdersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel!.guid,
        };

        if (shopGuid) {
            payload.shopGuid = shopGuid;
        }

        this.props.socket.emit(EndpointsEnum.ShopifyPullOrders, payload);

        this.setState(
            {
                shopifyPullOrdersActive: true,
            },
            () => {
                this.closeModal(false);
            }
        );
    };

    onShopifyPullOrders = (data: IOnShopifyPullOrdersDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_shopify_orders",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        // TODO Show the detail overview section on top.

        this.getOrders("onShopifyPullOrders");

        this.setState({
            shopifyPullOrdersActive: false,
        });
    };

    wayfairShowPullPurchaseOrdersModal = () => {
        const modalComponent = (
            <WayfairPurchaseOrderModal closeModalFn={this.closeModal} socket={this.props.socket} notifyFn={this.props.notifyFn} />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    pushWooCommerceOrders = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const orderGuids = _.map(checkedOrders, (order) => {
            return order.guid;
        });

        const payload: IWooCommercePushOrderDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel!.guid,
            orderGuids,
        };

        this.props.socket.emit(EndpointsEnum.WooCommercePushOrder, payload);
    };

    onPushWooCommerceOrders = (data: IWooCommerceOnPushOrderDTO) => {
        const notification: INotification = {
            message: "successfully_pushed_woocommerce_orders",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);
    };

    pullWooCommerceOrders = () => {
        const payload: IWooCommercePullOrdersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel!.guid,
        };

        this.props.socket.emit(EndpointsEnum.WooCommercePullOrders, payload);
    };

    pullOpenCartOrders = () => {
        const payload: IOpenCartPullOrdersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel!.guid,
        };

        this.props.socket.emit(EndpointsEnum.OpenCartPullOrders, payload);
    };

    onPullOpenCartOrders = (data: IOpenCartOnPullOrdersDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_orders",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.getOrders("onPullOpenCartOrders");
    };

    bulkConvertQuotesToOrders = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const quoteGuids =
            checkedOrders.map((checked) => {
                return checked.guid;
            }) || [];

        const payload: IBulkQuoteConvertDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel!.guid,
            quoteGuids,
        };

        this.props.socket.emit(EndpointsEnum.OrderEntryBulkQuoteConvert, payload);

        this.setState({
            bulkConvertQuotesActive: true,
        });
    };

    onBulkConvertQuotesToOrders = (data: IOnBulkQuoteConvertDTO) => {
        const message: INotification = {
            message: "successfully_converted_quotes_to_orders",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, message);

        this.setState({
            bulkConvertQuotesActive: false,
        });
    };

    showQboPullEstimatesModal = () => {
        const modalComponent = (
            <QboPullEstimatesModal
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                performPull={this.pullQboEstimates}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    pullQboEstimates = (_payload?: IQBOPullEstimatesDTO) => {
        let payload: IQBOPullEstimatesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel!.guid,
        };

        if (_payload) {
            payload = _payload;
        }

        this.props.socket.emit(EndpointsEnum.QBOPullEstimates, payload);

        this.setState({
            pullQboEstimatesActive: true,
        });
    };

    onPullQboEstimates = (data: IOnQBOPullEstimatesDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_qbo_estimates",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                pullQboEstimatesActive: false,
            },
            () => {
                this.getOrders("onPullQboEstimates");
            }
        );
    };

    getSupplier = () => {
        const payload: IGetSupplierDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel!.guid,
        };

        this.props.socket.emit(EndpointsEnum.SupplierGetSupplier, payload);
    };

    zoeyPullOrders = () => {
        const payload: IZoeyPullOrdersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel!.guid,
        };

        this.props.socket.emit(EndpointsEnum.ZoeyPullOrders, payload);

        this.setState({
            zoeyActive: true,
        });
    };

    onZoeyPullOrders = (data: any) => {
        const notification: INotification = {
            message: "successfully_pulled_orders",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            zoeyActive: false,
        });
    };

    bigCommercePullOrders = () => {
        const payload: IBigCommercePullOrdersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.BigCommercePullOrders, payload);

        this.setState({
            bigCommerceActive: true,
        });
    };

    onBigCommercePullOrders = (data: IBigCommerceOnPullOrdersDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_orders",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                bigCommerceActive: false,
            },
            () => {
                this.getOrders("onBigCommercePullOrders");
            }
        );
    };

    qboPullInvoicesAsOrders = (startDate: string, endDate?: string, docNumber?: string) => {
        if (this.state.qboActive) return;
        const payload: IQBOPullInvoicesAsOrdersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            startDate,
            endDate,
            docNumber,
        };

        this.setState({ qboActive: true, qboInvoiceSyncProgress: null }, () => {
            this.props.socket.emit(EndpointsEnum.QBOPullInvoicesAsOrders, payload);
        });
    };

    onQboSyncInvoicesUpdate = (data: IQBOSyncInvoicesUpdateDTO) => {
        this.setState((state) => (state.qboInvoiceSyncProgress !== undefined ? { qboInvoiceSyncProgress: data } : null));
    };

    onQboPullInvoicesAsOrders = (data: IQBOOnPullInvoicesAsOrdersDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_orders",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                qboActive: false,
                qboInvoiceSyncProgress: undefined,
            },
            () => {
                this.getOrders("onQboPullInvoicesAsOrders");
            }
        );
    };

    showQboBackfillInvoicePaidStatusModal = () => {
        const modalComponent = (
            <QboBackfillInvoicePaidStatusModal
                supplierModel={this.props.supplierModel}
                cancelFn={this.closeModal}
                startFn={this.qboBackfillInvoicePaidStatus}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    /**
     * Hidden admin tool: re-read the linked QuickBooks Online invoice balances and write the paid status onto the
     * orders (is_paid / qbo_InvoicePaid), limited by the modal's date range or order number so it can be run in
     * batches. Progress arrives on QBOSyncInvoicesUpdate like the invoice pull.
     */
    qboBackfillInvoicePaidStatus = (options: QboBackfillInvoicePaidStatusOptions) => {
        if (this.state.qboActive) return;

        const payload: IQBOBackfillInvoicePaidStatusDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            startDate: options.startDate,
            endDate: options.endDate,
            orderNo: options.orderNo,
            skipPaid: options.skipPaid,
        };

        this.setState({ qboActive: true, qboInvoiceSyncProgress: null }, () => {
            this.props.socket.emit(EndpointsEnum.QBOBackfillInvoicePaidStatus, payload);
        });
    };

    onQboBackfillInvoicePaidStatus = (data: IQBOOnBackfillInvoicePaidStatusDTO) => {
        const summary =
            `Linked Invoices: ${data.totalLinkedInvoices}, Found In QBO: ${data.totalInvoices}, ` +
            `Paid: ${data.totalPaid}, Open: ${data.totalOpen}, Orders Updated: ${data.totalOrdersUpdated}` +
            (data.totalErrors ? `, Failed Batches: ${data.totalErrors}` : "");

        const notification: INotification = {
            title: "successfully_backfilled_qbo_invoice_paid_status",
            message: summary,
            level: data.totalErrors ? NotificationLevelEnum.warning : NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
            autoDismiss: 0,
            dismissible: NotificationDismissibleEnum.CLICK,
            skipMessageTranslate: true,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                qboActive: false,
                qboInvoiceSyncProgress: undefined,
            },
            () => {
                this.getOrders("onQboBackfillInvoicePaidStatus");
            }
        );
    };

    showQboPullInvoicesAsOrdersModal = () => {
        const modalComponent = (
            <QboPullInvoicesAsOrdersModal
                userModel={this.props.userModel!}
                supplierModel={this.props.supplierModel}
                cancelFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                startFn={this.qboPullInvoicesAsOrders}
                hasDefaultPriceGroup={!!this.props.supplierModel?.Supplier_Integration?.qbo_DefaultPriceGroup}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    showCartCommissionBackfillModal = () => {
        const modalComponent = (
            <CartCommissionBackfillModal
                userModel={this.props.userModel!}
                supplierModel={this.props.supplierModel}
                notifyFn={this.props.notifyFn}
                cancelFn={this.closeModal}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    qboQueueCreateInvoices = () => {
        if (this.props.userModel) {
            const checkedOrders = this.getCheckedOrdersArr();

            const orderGuids = _.map(checkedOrders, (order: any) => {
                return order.guid;
            });

            if (orderGuids.length) {
                const payload: IQBOQueueCreateInvoicesDTO = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel!.guid,
                    orderGuids,
                };

                this.props.socket.emit(EndpointsEnum.QBOQueueCreateInvoices, payload);

                this.setState({
                    qboActive: true,
                });
            } else {
                const notification: INotification = {
                    message: "no_orders_selected",
                    level: NotificationLevelEnum.info,
                    position: NotificationPositionEnum.bc,
                };

                this.props.notifyFn(null, notification);
            }
        }
    };

    /**
     * Download or print the QBO invoices for the checked orders as one merged PDF
     * (REST: POST /qbo/invoices/bulk-pdf). QBO has no bulk PDF API, so the server fetches
     * each invoice PDF and merges them; orders it had to skip come back in the
     * X-QBO-Skipped-* headers.
     *
     * For "print" the tab is opened synchronously here, inside the click handler, because
     * popup blockers reject window.open once we're in an async continuation. If the browser
     * still blocks it we fall back to a download.
     */
    qboBulkInvoicePdf = async (mode: "download" | "print") => {
        if (!this.props.userModel) {
            return;
        }

        const orderGuids = _.map(this.getCheckedOrdersArr(), (order) => order.guid);

        if (!orderGuids.length) {
            this.props.notifyFn(null, {
                message: "no_orders_selected",
                level: NotificationLevelEnum.info,
                position: NotificationPositionEnum.bc,
            });

            return;
        }

        if (orderGuids.length > Orders.QBO_BULK_INVOICE_PDF_MAX_ORDERS) {
            this.props.notifyFn(null, {
                message: "too_many_orders_selected",
                level: NotificationLevelEnum.warning,
                position: NotificationPositionEnum.bc,
            });

            return;
        }

        const printWindow: Window | null = mode === "print" ? window.open("", "_blank") : null;

        this.setState({ qboBulkInvoicePdfActive: true });

        try {
            const url = buildRestUrl({ endpoint: RestEndpointsEnum.QBOBulkInvoicePdf });

            const headers = buildAuthHeadersForFetch({
                userModel: this.props.userModel,
                supplierModel: this.props.supplierModel!,
            });

            const response = await fetch(url, {
                method: "POST",
                headers,
                body: JSON.stringify({ orderGuids }),
            });

            if (!response.ok) {
                printWindow?.close();

                const isNoneFound = response.status === 404;

                if (!isNoneFound) {
                    const errorData = await response.json().catch(() => ({}));
                    console.error("Error retrieving QBO bulk invoice PDF:", response.status, errorData);
                }

                this.props.notifyFn(null, {
                    message: isNoneFound ? "no_qbo_invoices_found" : "error_qbo_bulk_invoice_pdf",
                    level: isNoneFound ? NotificationLevelEnum.warning : NotificationLevelEnum.error,
                    position: NotificationPositionEnum.bc,
                });

                return;
            }

            const blob = await response.blob();
            const objectUrl = window.URL.createObjectURL(blob);

            if (printWindow) {
                printWindow.location.href = objectUrl;
            } else {
                const contentDisposition = response.headers.get("Content-Disposition");
                const filenameMatch = contentDisposition ? contentDisposition.match(/filename="?([^"]+)"?/) : null;

                const link = document.createElement("a");
                link.href = objectUrl;
                link.download = filenameMatch ? filenameMatch[1] : "QuickBooks Invoices.pdf";
                link.click();
            }

            const skippedCount = parseInt(response.headers.get("X-QBO-Skipped-Count") || "0", 10);

            if (skippedCount > 0) {
                const skippedItemsHeader = response.headers.get("X-QBO-Skipped-Items");

                if (skippedItemsHeader) {
                    try {
                        console.warn("QBO invoices skipped:", JSON.parse(window.atob(skippedItemsHeader)));
                    } catch (parseErr) {
                        console.warn("QBO invoices skipped (unparseable detail):", skippedItemsHeader);
                    }
                }

                this.props.notifyFn(null, {
                    title: "qbo_invoices_skipped",
                    message: `${skippedCount} / ${orderGuids.length}`,
                    level: NotificationLevelEnum.warning,
                    position: NotificationPositionEnum.bc,
                    skipMessageTranslate: true,
                });
            }
        } catch (err) {
            printWindow?.close();

            console.error("Error retrieving QBO bulk invoice PDF:", err);

            this.props.notifyFn(null, {
                message: "error_qbo_bulk_invoice_pdf",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            });
        } finally {
            this.setState({ qboBulkInvoicePdfActive: false });
        }
    };

    /** Documents-menu action for the Route Pick List workbook export (OR-1500). */
    getExportRoutePickListAction = (): IAction => {
        return {
            name: "export_route_pick_list",
            fn: this.exportRoutePickList,
            leftIconClass: "fad fa-file-excel",
            isActive: () => {
                return this.state.routePickListActive;
            },
            disabledFn: () => {
                return this.state.routePickListActive || !this.state.numCheckBoxChecked;
            },
        };
    };

    /**
     * POST the selected order guids to /v1/routes/pick-list-export and download the .xlsx:
     * one tab per route (every active customer on the route as a column in stop order) plus Grand Totals.
     */
    exportRoutePickList = async () => {
        if (!this.props.userModel || !this.props.supplierModel) {
            return;
        }

        const orderGuids = _.map(this.getCheckedOrdersArr(), (order) => order.guid);

        if (!orderGuids.length) {
            this.props.notifyFn(null, {
                message: "no_orders_selected",
                level: NotificationLevelEnum.info,
                position: NotificationPositionEnum.bc,
            });

            return;
        }

        if (orderGuids.length > Orders.ROUTE_PICK_LIST_MAX_ORDERS) {
            this.props.notifyFn(null, {
                message: "too_many_orders_selected_route_pick_list",
                level: NotificationLevelEnum.warning,
                position: NotificationPositionEnum.bc,
            });

            return;
        }

        this.setState({ routePickListActive: true });

        try {
            const url = buildRestUrl({ endpoint: RestEndpointsEnum.RoutesPickListExport });

            const headers = buildAuthHeadersForFetch({
                userModel: this.props.userModel,
                supplierModel: this.props.supplierModel,
            });

            const response = await fetch(url, {
                method: "POST",
                headers,
                body: JSON.stringify({ orderGuids }),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                console.error("Error exporting route pick list:", response.status, errorData);

                this.props.notifyFn(null, {
                    message: response.status === 404 ? "no_orders_selected" : "error_export_route_pick_list",
                    level: response.status === 404 ? NotificationLevelEnum.warning : NotificationLevelEnum.error,
                    position: NotificationPositionEnum.bc,
                });

                return;
            }

            const blob = await response.blob();
            const objectUrl = window.URL.createObjectURL(blob);
            const contentDisposition = response.headers.get("Content-Disposition");
            const filenameMatch = contentDisposition ? contentDisposition.match(/filename="?([^"]+)"?/) : null;

            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = filenameMatch ? filenameMatch[1] : "Route Pick List.xlsx";
            link.click();
            window.URL.revokeObjectURL(objectUrl);
        } catch (err) {
            console.error("Error exporting route pick list:", err);

            this.props.notifyFn(null, {
                message: "error_export_route_pick_list",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            });
        } finally {
            this.setState({ routePickListActive: false });
        }
    };

    onQboCreateInvoices = (data: IQBOOnQueueCreateInvoicesDTO) => {
        const notification: INotification = {
            message: "successfully_queued_orders",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            qboActive: false,
            qboInvoiceSyncProgress: undefined,
        });
    };

    createQbdSalesOrders = () => {
        if (this.props.userModel) {
            const checkedOrders = this.getCheckedOrdersArr();

            const orderGuids = _.map(checkedOrders, (order: any) => {
                return order.guid;
            });

            const payload: IQBDCreateDTO = {
                resource: QBDResourceTypesEnum.SALES_ORDER,
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel!.guid,
                orderGuids,
            };

            this.props.socket.emit(EndpointsEnum.QBDCreate, payload);

            this.setState({
                createQbdSalesOrdersActive: true,
            });
        }
    };

    onQBDCreate = (data: IOnQBDCreateDTO) => {
        const notification: INotification = {
            title: "quickbooks_desktop_orders_scheduled_for_creation",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);
        const updatedCheckBoxChecked = this.setAllCheckBox(false);

        this.setState(
            {
                checkBoxChecked: updatedCheckBoxChecked,
                createQbdSalesOrdersActive: false,
                createQbdInvoiceActive: false,
            },
            () => {
                this.getOrders("onQBDCreate");
                this.getSupplier();
            }
        );
    };

    createPickList = () => {
        if (this.props.userModel) {
            const checkedOrders = this.getCheckedOrdersArr();

            if (this.props.supplierModel.has_pick_list_management) {
                // first check and see if any picklists were created today, and if so, then notify the user.
                let hasExistingPickLists = false;
                const pickLists: IPick_List[] = [];

                checkedOrders.forEach((order) => {
                    for (const orderDetail of this.state.orders) {
                        if (orderDetail.guid === order.guid) {
                            if (orderDetail.Pick_Lists && orderDetail.Pick_Lists.length) {
                                hasExistingPickLists = true;
                                pickLists.push(...orderDetail.Pick_Lists);
                            }
                        }
                    }
                });

                const payload: ICreatePickListDTO = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel!.guid,
                    orderGuids: checkedOrders.map((order) => {
                        return order.guid;
                    }),
                };

                if (!hasExistingPickLists) {
                    this.props.socket.emit(EndpointsEnum.OrderCreatePickList, payload);

                    this.setState({
                        isPickListActive: true,
                    });
                } else {
                    const modalComponent = (
                        <PickListExistsModal
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            setActivityIndicator={this.props.setActivityIndicator}
                            socket={this.props.socket}
                            notifyFn={this.props.notifyFn}
                            pickLists={pickLists}
                            payload={payload}
                            cancelFn={this.closeModal}
                        />
                    );

                    this.setState({
                        modalComponent,
                        modalIsOpen: true,
                    });
                }
            } else {
                const orders = checkedOrders.map((checkedOrder) => {
                    return checkedOrder.guid;
                });

                const combinedOrders = orders.join(",");

                this.props.history(`/orders/pick_list?orders=${combinedOrders}`);
            }

            this.toggleButtonActive("Create Pick List");
        }
    };

    onCreatePickList = (data: IOnCreatePickListDTO) => {
        this.setState(
            {
                isPickListActive: false,
            },
            () => {
                if (data.pickList.length === 1) {
                    const pickList = data.pickList[0]!;
                    this.props.history(`/pick_lists/${pickList.guid}`);
                } else {
                    this.props.history(`/pick_lists`);
                }
            }
        );
    };

    getOptimizedRoute = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        if (checkedOrders.length >= 3) {
            const modalComponent = (
                <RouteOptimizationModal
                    orders={checkedOrders}
                    socket={this.props.socket}
                    notifyFn={this.props.notifyFn}
                    closeFn={this.closeModal}
                />
            );

            this.setState({
                modalComponent,
                modalIsOpen: true,
            });
        } else {
            const notification: INotification = {
                message: "select_at_least_3_orders",
                level: NotificationLevelEnum.info,
                position: NotificationPositionEnum.bc,
            };

            this.props.notifyFn(null, notification);
        }
    };

    createPackingList = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const orderGuids = _.map(checkedOrders, (order: any) => {
            return order.guid;
        });

        this.props.history(`/orders/packing_list?orders=${orderGuids.join(",")}`);
    };

    createBillOfLading = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const orderGuids = _.map(checkedOrders, (order: any) => {
            return order.guid;
        });

        this.props.history(`/orders/bill_of_lading?orders=${orderGuids.join(",")}`);
    };

    /**
     * Sales Order and Invoice documents render one page per selected order, like the packing list.
     * Returns the selected guids, or null (after notifying) when the selection can't be sent.
     */
    getBulkDocumentOrderGuids = (): string[] | null => {
        const orderGuids = _.map(this.getCheckedOrdersArr(), (order) => order.guid);

        if (!orderGuids.length) {
            this.props.notifyFn(null, {
                message: "no_orders_selected",
                level: NotificationLevelEnum.info,
                position: NotificationPositionEnum.bc,
            });

            return null;
        }

        if (orderGuids.length > Orders.BULK_DOCUMENTS_MAX_ORDERS) {
            this.props.notifyFn(null, {
                message: "too_many_orders_selected",
                level: NotificationLevelEnum.warning,
                position: NotificationPositionEnum.bc,
            });

            return null;
        }

        return orderGuids;
    };

    createSalesOrder = () => {
        const orderGuids = this.getBulkDocumentOrderGuids();

        if (orderGuids) {
            this.props.history(`/orders/sales_order?orders=${orderGuids.join(",")}`);
        }
    };

    createInvoice = () => {
        const orderGuids = this.getBulkDocumentOrderGuids();

        if (orderGuids) {
            this.props.history(`/orders/invoice?orders=${orderGuids.join(",")}`);
        }
    };

    bulkOrderSubmit = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const orderGuids = checkedOrders.map((checkedOrder) => {
            return checkedOrder.guid;
        });

        const component = (
            <BulkOrderSubmitModal
                selectAll={this.state.selectAll}
                orderGuids={orderGuids}
                supplierModel={this.props.supplierModel}
                userModel={this.props.userModel}
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
            />
        );

        this.setState({
            modalComponent: component,
            modalIsOpen: true,
        });
    };

    bulkDeallocateInventory = () => {
        const checkedOrders = this.getCheckedOrdersArr();
        const orderGuids = checkedOrders.map((o) => o.guid);

        const summaryRows = checkedOrders.map((o) => ({
            label: o.name,
            detail: o.guid,
        }));

        const component = (
            <DeallocateInventoryModal
                closeModalFn={() => this.closeModal()}
                onDeallocateFn={(note: string, releasePending: boolean, releaseToAvailable: boolean) => {
                    this.deallocateInventoryBulkAPI(orderGuids, note, releasePending, releaseToAvailable);
                }}
                summaryRows={summaryRows}
            />
        );

        this.setState({
            modalComponent: component,
            modalIsOpen: true,
        });
    };

    deallocateInventoryBulkAPI = async (orderGuids: string[], note: string, releasePending: boolean, releaseToAvailable: boolean) => {
        this.setState({
            modalIsOpen: false,
            modalComponent: null,
        });

        try {
            const ky = (await import("ky")).default;
            const { buildAuthHeadersForKy, buildRestUrl } = await import("../../../services/RestService");
            const RestEndpointsEnum = (await import("../../../models/RestEndpointsEnum")).default;

            const url = buildRestUrl({
                endpoint: RestEndpointsEnum.DeallocateOrderInventoryBulk,
            });

            const headers = buildAuthHeadersForKy({
                userModel: this.props.userModel!,
                supplierModel: this.props.supplierModel!,
            });

            const response = await ky.post(url, {
                json: {
                    orderGuids,
                    releasePending,
                    releaseToAvailable: releaseToAvailable || undefined,
                    note: note || undefined,
                },
                headers,
            });

            const data = await response.json<IOnDeallocateInventoryDTO>();

            if (data.success) {
                const parts = [`De-allocated ${data.totalDeallocated} unit(s) across ${orderGuids.length} order(s)`];
                if (data.totalPendingReleased > 0) {
                    parts.push(`${data.totalPendingReleased} pending released`);
                }

                const notification: INotification = {
                    message: parts.join(", "),
                    level: NotificationLevelEnum.success,
                    position: NotificationPositionEnum.bc,
                    skipMessageTranslate: true,
                };

                this.props.notifyFn(null, notification);

                // Warn about any per-order failures
                if (data.orders) {
                    const failedOrders = data.orders.filter((o) => o.error);
                    if (failedOrders.length) {
                        const failedNames = failedOrders.map((o) => o.orderName || o.orderGuid).join(", ");
                        const warningNotification: INotification = {
                            message: `Failed for: ${failedNames}`,
                            level: NotificationLevelEnum.error,
                            position: NotificationPositionEnum.bc,
                            skipMessageTranslate: true,
                        };

                        this.props.notifyFn(null, warningNotification);
                    }
                }
            } else {
                const notification: INotification = {
                    message: "deallocate_inventory_failed",
                    level: NotificationLevelEnum.error,
                    position: NotificationPositionEnum.bc,
                };

                this.props.notifyFn(null, notification);
            }

            const updatedCheckBoxChecked = this.setAllCheckBox(false);

            this.setState(
                {
                    checkBoxChecked: updatedCheckBoxChecked,
                    hasOneChecked: false,
                    numCheckBoxChecked: 0,
                },
                () => {
                    this.getOrders("onBulkDeallocateInventory");
                }
            );
        } catch (err: any) {
            const notification: INotification = {
                message: "deallocate_inventory_failed",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            };

            this.props.notifyFn(null, notification);
        }
    };

    releaseCommissions = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        if (checkedOrders) {
            const payload: IReleaseOrderCommissionDTO = {
                userGuid: this.props.userModel!.guid,
                userToken: this.props.userModel!.token,
                supplierGuid: this.props.supplierModel!.guid,
                orders: checkedOrders,
                releaseCommission: true,
            };

            this.props.socket.emit(EndpointsEnum.OrderReleaseOrderCommission, payload);

            this.toggleButtonActive("Release Commission");
        }
    };

    onReleaseOrderCommission = (data: IOnReleaseOrderCommissionDTO) => {
        const notification: INotification = {
            title: "successfully_released_commissions",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification, false);
        const updatedCheckBoxChecked = this.setAllCheckBox(false);

        this.setState(
            {
                checkBoxChecked: updatedCheckBoxChecked,
            },
            () => {
                this.getOrders("onReleaseOrderCommission");
            }
        );
    };

    toggleButtonActive = (title: string) => {
        const actions = this.state.actions;

        if (!actions) {
            return;
        }

        for (const action of actions) {
            if (action.name === title) {
                action.isActive = !action.isActive;
            }
        }

        this.setState({ actions });
    };

    togglePrintView = () => {
        // let printViewComponent;

        // if (this.state.printView) {
        //     printViewComponent = null;
        // }

        this.setState({
            printView: !this.state.printView,
            // printViewComponent
        });
    };

    determineExportOrdersArr = () => {
        const exportOrders = this.state.exportOrders;

        const checkBoxChecked = this.state.checkBoxChecked;

        _.each(checkBoxChecked, (checkDetail) => {
            let found = false;

            _.map(exportOrders, (order) => {
                if (checkDetail.orderGuid === order.guid) {
                    found = true;
                }
            });

            if (!found && checkDetail.checked) {
                exportOrders.push({
                    guid: checkDetail.orderGuid,
                    name: checkDetail.name,
                });
            }
        });

        return exportOrders;
    };

    createBulkPdf = () => {
        const checkedOrders = this.getCheckedOrdersArr();

        const orderGuids = _.map(checkedOrders, (order: any) => {
            return order.guid;
        });

        const payload: IGenerateBulkOrderPdfDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel!.guid,
            orderGuids,
        };

        this.props.socket.emit(EndpointsEnum.OrderGenerateBulkOrderPDF, payload);
    };

    onCreateBulkPdf = (data: IOnGenerateBulkOrderPdfDTO) => {
        const blob = new Blob([data.pdf], { type: "application/pdf" }); // change resultByte to bytes

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        link.download = _.get(this.props, "fileName", `${data.filename}.pdf`);
        link.click();
    };

    addToExport = () => {
        const exportOrders = this.determineExportOrdersArr();

        // exportOrders.push(order);

        const updatedCheckBoxChecked = this.setAllCheckBox(false);

        this.setState({
            exportOrders,
            checkBoxChecked: updatedCheckBoxChecked,
            checkAll: false,
            hasOneChecked: false,
        });
    };

    onGetOrders = (data: IOnGetOrdersDTO) => {
        const { orders, totalOrders } = data;

        const columns = this.state.columns;

        const processedOrders: IOrderUI[] = (orders || []).map((order) => {
            if (_.get(order, "Supplier.has_local_delivery", false)) {
                this.hasLocalDelivery = true;

                columns.local_delivery.notVisible = false;
                columns.local_delivery.isChecked = true;
            }

            return {
                ...order,
            } as IOrderUI;
        });

        this.setState(
            {
                orders: processedOrders,
                totalOrders,
                checkAll: false,
                initialFetch: false,
                isInitialData: false,
                isDataFetching: false,
                checkBoxChecked: [],
                numCheckBoxChecked: 0,
                columns,
            },
            () => {
                this.props.setActivityIndicator(false);
            }
        );
    };

    onGetOrder = (data: IOnGetOrderDTO) => {};

    onGetClients = (data: IOnGetClientsDTO) => {
        const { clients } = data;

        this.setState({
            clients,
        });
    };

    paginationChanged = (offset: number, limit: number) => {
        this.setState(
            {
                isDataFetching: false,
                offset,
                limit,
            },
            () => {
                this.getOrders("paginationChanged");

                if (this.props.onPaginationUrlChange) {
                    this.props.onPaginationUrlChange(offset + 1, limit);
                }
            }
        );
    };

    setCurrentQueryStringArr = (queryStringArr: string[]) => {
        this.setState({
            queryStringArr,
        });
    };

    toggleSortDir = (sortCol: string, sortOrder: SortOrderEnum, apiSortCol?: string) => {
        const queryString = OrdersService.getQueryString(apiSortCol || sortCol, sortOrder, undefined, this.state.queryStringArr);

        this.setState({ sortOrder, sortCol, queryString }, () => {
            this.getOrders("toggleSortDir");
        });
    };

    getOrders = async (callingFn: string, includePercentageFillable?: boolean) => {
        // console.log("getOrders");
        const forceOnline = UserService.getForceOnline();

        if (this.props.userModel && !this.state.isDataFetching) {
            // @ts-expect-error
            const payload: IGetOrdersDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                limit: this.state.limit,
                offset: this.state.offset,
                queryString: OrdersService.withIncludeShipments(this.state.queryString, this.isTrackingColumnOn()),
                includePercentageFillable,
                callMeta: {
                    view: "Orders",
                    fn: "getOrders",
                    callingFn,
                },
            };

            if (this.props.userModel.isSupplierUser) {
                payload.supplierGuid = this.props.supplierModel!.guid;
            }

            if (this.props.vendorModel) {
                payload.supplierGuid = this.props.supplierModel!.guid;
                payload.vendorGuid = this.props.vendorModel.guid;
            }

            const offlineOrders = await this.idbService.getOrders();

            if ((!this.state.isOnline || !navigator.onLine) && !forceOnline) {
                this.props.setActivityIndicator(false);

                const state: any = {
                    offlineOrders,
                    initialFetch: false,
                    isDataFetching: true,
                };

                this.setState(state);
            } else {
                this.props.socket.emit(EndpointsEnum.OrderGetOrders, payload);

                if (offlineOrders.length) {
                    this.setState({
                        hasOfflineOrders: true,
                        offlineOrders,
                        initialFetch: true,
                        isDataFetching: true,
                    });
                } else {
                    this.setState({
                        hasOfflineOrders: false,
                        isDataFetching: true,
                    });
                }
            }
        }
    };

    getOrdersRest = async (callingFn: string, includePercentageFillable?: boolean) => {
        if (!this.props.userModel || !this.props.supplierModel || this.state.isDataFetching) {
            return;
        }

        try {
            // Build authentication headers
            const headers = buildAuthHeadersForFetch({
                userModel: this.props.userModel,
                supplierModel: this.props.supplierModel,
                vendorModel: this.props.vendorModel,
            });

            // Build URL with query parameters
            const queryParams: Record<string, any> = {
                offset: this.state.offset,
                limit: this.state.limit,
            };

            // Add optional parameters
            if (includePercentageFillable) {
                queryParams.includePercentageFillable = includePercentageFillable;
            }

            if (this.state.queryString) {
                queryParams.queryString = this.state.queryString;

                if (this.state.useSequelize) {
                    queryParams.queryString += "&method=sqlz";
                }
            } else {
                if (this.state.useSequelize) {
                    queryParams.queryString = "?method=sqlz";
                }
            }

            // OR-1486: only ask for shipments while the Tracking # column is on (keeps the default payload small)
            queryParams.queryString = OrdersService.withIncludeShipments(queryParams.queryString, this.isTrackingColumnOn());

            const url = buildRestUrlWithQuery({
                endpoint: RestEndpointsEnum.GetOrdersWithAuth,
                query: queryParams,
            });

            // Set loading state
            this.setState({ isDataFetching: true });

            // Make REST call
            const response = await fetch(url, {
                method: "GET",
                headers,
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch orders: ${response.statusText}`);
            }

            // Parse response
            const data: { success: boolean; orders: IOrder[]; totalOrders: number; resource: string } = await response.json();

            if (data.success) {
                // Reuse existing onGetOrders handler logic
                this.onGetOrders({
                    orders: data.orders,
                    totalOrders: data.totalOrders,
                    resource: data.resource,
                });
            } else {
                throw new Error("Failed to fetch orders");
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
            this.setState({ isDataFetching: false });
            this.props.setActivityIndicator(false);

            // Handle error notification
            this.props.notifyFn({
                eid: "Failed to load orders",
                message: "Failed to load orders",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            });
        }
    };

    // Is this even available any more?
    onUpdateOrder = (data: any) => {
        this.getOrders("onUpdateOrder");
    };

    onDeleteOrder = (data: IOnDeleteOrderDTO) => {
        this.getOrders("onDeleteOrder");
    };

    getCreateOrderSidebar = () => {
        if (this.props.supplierModel && this.props.vendorModel && this.props.userModel) {
            if (this.state.newCreateOrderSidebar) {
                return (
                    <CreateOrderFnSidebar
                        cancelFn={this.props.toggleSidebar}
                        socket={this.props.socket}
                        isOnline={this.state.isOnline && navigator.onLine}
                        notifyFn={this.props.notifyFn}
                        setActivityIndicator={this.props.setActivityIndicator}
                        setSidebarComponent={this.props.setSidebarComponent}
                        toggleSidebar={this.props.toggleSidebar}
                    />
                );
            } else {
                return (
                    <CreateOrderSidebar
                        isQuote={this.props.is_quotes}
                        isTemplate={this.props.is_templates}
                        history={this.props.history}
                        supplierModel={this.props.supplierModel}
                        userModel={this.props.userModel}
                        vendorModel={this.props.vendorModel}
                        cancelFn={this.props.toggleSidebar}
                        socket={this.props.socket}
                        isOnline={this.state.isOnline && navigator.onLine}
                        notifyFn={this.props.notifyFn}
                        setActivityIndicator={this.props.setActivityIndicator}
                        setSidebarComponent={this.props.setSidebarComponent}
                        toggleSidebar={this.props.toggleSidebar}
                    />
                );
            }
        }
    };

    onCreateOrder = (data: IOnCreateOrderDTO) => {
        // console.log(data);
        // this.getOrders();
        this.props.toggleSidebar(false);
        this.props.setSidebarComponent(null);

        let url = `/orders/${data.order!.guid}/entry`;

        if (data.order.is_quote) {
            url = `/quotes/${data.order!.guid}/entry`;
        }

        if (this.props.supplierModel.has_ecommerce_view) {
            if (this.props.supplierModel.ecommerce_default_view) {
                url = `/orders/${data.order!.guid}/ecom`;
            }
        }

        this.props.history(url);
    };

    createNewOrderSidebar = () => {
        const createOrderSidebar = this.getCreateOrderSidebar();
        this.props.setSidebarComponent(createOrderSidebar);
        this.props.toggleSidebar(true);
    };

    toggleRowEditMode = (rowData: any, index: number, saveData: boolean) => {
        // console.log(rowData, index);
        const orders = { ...this.state.orders };
        // @ts-expect-error
        orders[index].rowEditMode = !rowData.rowEditMode;
        // @ts-expect-error
        if (this.state.orders[index].rowEditMode) {
            const rowCopy = _.cloneDeep(orders[index]);
            // @ts-expect-error
            orders[index].tempRow = rowCopy;
        } else {
            // if the row is dirty, then we should see if accept or cancel was selected
            if (saveData) {
                if (this.props.supplierModel && this.props.vendorModel && this.props.userModel) {
                    // @ts-expect-error
                    const tempRow = _.cloneDeep(orders[index].tempRow);
                    tempRow.rowEditMode = false;
                    // @ts-expect-error
                    delete orders[index].tempRow;

                    orders[index] = tempRow;

                    const row = orders[index];

                    // @ts-expect-error
                    row.vendorGuid = this.props.vendorModel.guid;
                    // @ts-expect-error
                    row.supplierGuid = this.props.supplierModel.guid;
                    // @ts-expect-error
                    row.userToken = this.props.userModel.token;
                    // @ts-expect-error
                    row.userGuid = this.props.userModel.guid;
                    // @ts-expect-error
                    row.client_id = parseInt(row.client_id);
                    // @ts-expect-error
                    row.orderGuid = row.guid;

                    if (_.isNil(row.guid)) {
                        this.props.socket.emit(EndpointsEnum.OrderCreateOrder, row);
                    } else {
                        this.props.socket.emit(EndpointsEnum.OrderEntryUpdateOrderEntryDetail, row);
                    }
                }
            } else {
                // @ts-expect-error
                orders[index].tempRow = undefined;

                if (_.isNil(orders[index].guid)) {
                    orders.splice(0, 1);
                }
            }
        }

        this.setState({
            orders,
        });
        // @ts-expect-error
        // console.log("Show Edit Mode: " + this.state.orders[index].rowEditMode);

        // this.forceUpdate();
    };

    toggleConfirmDelete = (e: any, data: any, index: number) => {
        this.deleteIndex = index;

        this.setState(
            {
                sourceElementRef: `row-${index}`,
                deleteSource: data,
            },
            () => {
                this.forceUpdate();
            }
        );
    };

    commitDelete = async () => {
        // @ts-expect-error
        // this.refs["overlayRow"].style.display = "none";

        const orders = this.state.orders || [];
        const offlineOrders = this.state.offlineOrders || [];

        const row: any = this.state.deleteSource; // (!_.isNil(this.deleteIndex) && this.state.orders[this.deleteIndex]) || ({} as any);

        // console.log("commitDelete", row, this.deleteIndex, this.state.orders);

        if (!_.isNil(row.offlineGuid)) {
            // soft delete the order in the jsstore
            // @ts-expect-error

            if (!_.isNil(this.deleteIndex)) {
                const offlineRow = this.state.offlineOrders[this.deleteIndex] || ({} as any);
                // console.log("offline row: ", offlineRow, this.deleteIndex, this.state.offlineOrders);
                await this.idbService.deleteOrderByLocalGuid(offlineRow.offlineGuid);
                const splicedOrders = offlineOrders.splice(this.deleteIndex, 1);
            }
        } else {
            if (this.props.supplierModel && this.props.vendorModel && this.props.userModel) {
                const payload: IDeleteOrderDTO = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel.guid,
                    vendorGuid: this.props.vendorModel.guid,
                    orderGuid: row.guid,
                };

                this.props.socket.emit(EndpointsEnum.OrderDeleteOrder, payload);
            }
        }

        this.deleteIndex = undefined;

        const state: any = {
            // orders,
            // offlineOrders,
            sourceElementRef: null,
            deleteSource: null,
        };

        this.setState(state, () => {
            this.cancelDelete();

            if (row.offlineGuid) {
                this.getOrders("commitDelete");
            }
        });
    };

    cancelDelete = () => {
        this.deleteIndex = undefined;

        this.setState({
            sourceElementRef: null,
        });
    };

    filterOrders = (queryString: string, percentage_fillable?: boolean, isReset?: boolean) => {
        try {
            let sortCol = this.state.sortCol;
            let sortOrder = this.state.sortOrder;

            if (isReset) {
                sortCol = this.props.supplierModel.guid === SupplierGuidEnum.VERMONT ? "order" : "updated_at";
                sortOrder = this.props.supplierModel.guid === SupplierGuidEnum.VERMONT ? SortOrderEnum.ASC : SortOrderEnum.DESC;
            }

            // console.log("filterOrders", queryString);

            const completeQueryString = OrdersService.getQueryString(sortCol, sortOrder, queryString);

            this.setState(
                {
                    queryString: completeQueryString,
                    offset: 0,
                    sortCol,
                    sortOrder,
                },
                () => {
                    this.getOrdersRest("filterOrders", percentage_fillable);
                }
            );
        } catch (err) {
            console.log(err);
        }
    };

    toggleCheckBox = (data: IOrder, index: number) => {
        const currentCheckBoxChecked = [...this.state.checkBoxChecked];

        currentCheckBoxChecked[index].checked = !currentCheckBoxChecked[index].checked;

        const elem = document.getElementById(`row-${index}`);

        if (currentCheckBoxChecked[index].checked) {
            elem!.classList.add("highlight-row");
        } else {
            elem!.classList.remove("highlight-row");
        }

        let numCheckBoxChecked = 0;

        for (const checkBoxDetail of currentCheckBoxChecked) {
            if (checkBoxDetail.checked) {
                numCheckBoxChecked++;
            }
        }

        const hasOneChecked = numCheckBoxChecked >= 1;

        this.setState(
            {
                hasOneChecked,
                numCheckBoxChecked,
                checkBoxChecked: currentCheckBoxChecked,
            },
            () => {
                console.timeEnd("toggleCheckbox");
            }
        );
    };

    checkAll = (isChecked: boolean) => {
        const checkedBoxes = this.setAllCheckBox(isChecked);

        const numCheckBoxChecked = isChecked ? checkedBoxes.length : 0;

        this.setState({
            checkBoxChecked: checkedBoxes,
            hasOneChecked: isChecked,
            numCheckBoxChecked,
        });
    };

    setAllCheckBox = (isChecked: boolean) => {
        const updatedCheckBoxChecked = _.map(this.state.checkBoxChecked, (checkBoxDetail) => {
            const updatedDetail = Object.assign({}, checkBoxDetail);
            updatedDetail.checked = isChecked;
            return updatedDetail;
        });

        return updatedCheckBoxChecked;
    };

    submitExports = (template: any, orders: any) => {
        if (this.props.supplierModel && this.props.vendorModel && this.props.userModel) {
            // console.log("template", template, "orders", orders);

            const filteredOrders = _.filter(orders, (order) => {
                return !order.deleteFlag;
            });

            const processedOrders: any[] = _.map(filteredOrders, (order) => {
                return order.guid;
            });

            const payload = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                vendorGuid: this.props.vendorModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                template,
                order: processedOrders,
                resourceType: "order",
            };

            this.props.socket.emit(EndpointsEnum.ExportCreateExport, payload);
        }
    };

    clearAllExports = () => {
        const updatedCheckBoxChecked = this.setAllCheckBox(false);

        this.setState({
            exportOrders: [],
            checkBoxChecked: updatedCheckBoxChecked,
        });
    };

    getSidebarComponent = () => {
        return (
            <ExportSidebar
                supplierModel={this.props.supplierModel}
                label={"orders"}
                items={this.state.exportOrders}
                submitFn={this.submitExports}
                clearAllFn={this.clearAllExports}
                // clearSingleFn={this.clearSingleExport}
                fieldTitle={"Name"}
                fieldProp={"name"}
                cancel={this.props.toggleSidebar}
            />
        );
    };

    openExportsSidebar = () => {
        const sidebarComp = this.getSidebarComponent();
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar();
    };

    onCreateExport = (data: any) => {
        if (!_.isNil(data.exportDetail)) {
            this.clearAllExports();
        }
    };

    toggleDock = () => {
        this.setState(
            {
                isDockVisible: !this.state.isDockVisible,
            },
            () => {
                if (this.state.isDockVisible) {
                    window.print();
                }
            }
        );
    };

    getShowCheckboxes = () => {
        if (this.props.userModel) {
            return !!this.props.userModel.isSupplierUser;
        } else {
            return false;
        }
    };

    toggleCurrencyConversions = () => {
        this.setState({
            doCurrencyConversion: !this.state.doCurrencyConversion,
        });
    };

    toggleSequelize = () => {
        this.setState({
            useSequelize: !this.state.useSequelize,
        });
    };

    getTitle = () => {
        let title = "orders";

        title = SupplierService.updateStringWithOrderNameOverride("orders", this.props.supplierModel);

        if (this.props.supplierModel.guid === SupplierGuidEnum.PANASONIC_CA) {
            title = "deal_registrations";
        }

        return title;
    };

    getSectionTitle = (showCheckBoxes: boolean) => {
        if (this.props.supplierModel && this.props.userModel) {
            if (this.props.is_quotes) {
                return (
                    <div className={"row d-flex w-100 align-items-center"}>
                        <div className={"col d-flex align-items-center"}>
                            <OwTitle className={"mt-3 d-inline-flex me-3"} tag={"h2"} title={"quotes"} leftIconName={"fad fa-file-alt"} />
                            <div
                                className={
                                    (this.props.supplierModel &&
                                        this.props.supplierModel.disable_vendor_order_entry &&
                                        !this.props.userModel.isSupplierUser) ||
                                    this.props.userModel.supplierUserToken?.Access_Type?.id === AccessTypesEnum.READ_ONLY
                                        ? "d-none"
                                        : "d-inline-flex"
                                }>
                                <div>
                                    {(this.props.supplierModel.disable_vendor_quote_order_entry && !this.props.userModel.isSupplierUser) ||
                                    this.props.userModel.supplierUserToken?.Access_Type?.id === AccessTypesEnum.READ_ONLY ||
                                    this.props.isReadOnly ? null : (
                                        <OwButton
                                            tabIndex={1}
                                            disabled={this.state.disableCreateOrder}
                                            active={this.state.activeCreateOrder}
                                            leftIconClass="fas fa-plus"
                                            className="btn-warning d-print-none"
                                            title="create"
                                            fn={this.createNewOrderSidebar}
                                        />
                                    )}
                                </div>
                            </div>
                            {/* Legacy / FilterBar (v2) search toggle, and the portal target for the v2 Refresh + Filters buttons */}
                            <div className={"ms-auto d-flex align-items-center"}>
                                <FilterBarVersionToggle />
                                <div id={"orders-filter-actions"} className={"d-flex align-items-center ms-2 d-print-none"} />
                            </div>
                        </div>
                    </div>
                );
            } else if (this.props.is_templates) {
                return (
                    <div className={"row d-flex w-100 align-items-center"}>
                        <div className={"col d-flex align-items-center"}>
                            <OwTitle
                                className={"mt-3 d-inline-flex me-3"}
                                tag={"h2"}
                                title={"templates"}
                                leftIconName={"fad fa-compass-drafting"}
                            />
                            <div
                                className={
                                    (this.props.supplierModel &&
                                        this.props.supplierModel.disable_vendor_order_entry &&
                                        !this.props.userModel.isSupplierUser) ||
                                    this.props.isReadOnly ||
                                    this.props.userModel.supplierUserToken?.Access_Type?.id === AccessTypesEnum.READ_ONLY
                                        ? "d-none"
                                        : "d-inline-flex"
                                }>
                                <div>
                                    <OwButton
                                        tabIndex={1}
                                        disabled={this.state.disableCreateOrder}
                                        active={this.state.activeCreateOrder}
                                        leftIconClass="fas fa-plus"
                                        className="btn-warning d-print-none"
                                        title="create"
                                        fn={this.createNewOrderSidebar}
                                    />
                                </div>
                            </div>
                            {/* Legacy / FilterBar (v2) search toggle, and the portal target for the v2 Refresh + Filters buttons */}
                            <div className={"ms-auto d-flex align-items-center"}>
                                <FilterBarVersionToggle />
                                <div id={"orders-filter-actions"} className={"d-flex align-items-center ms-2 d-print-none"} />
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className={"d-flex w-100 align-items-center"}>
                        <div className={"d-flex w-100 mt-3 mb-2 align-items-center"}>
                            <OwTitle className={"me-3"} tag={"h2"} title={this.getTitle()} leftIconName={"fad fa-list-alt"} />
                            <div
                                className={
                                    (this.props.supplierModel &&
                                        (this.props.supplierModel.require_quote_to_order ||
                                            (this.props.supplierModel.disable_vendor_order_entry &&
                                                !this.props.userModel.isSupplierUser))) ||
                                    this.props.userModel.supplierUserToken?.Access_Type?.id === AccessTypesEnum.READ_ONLY
                                        ? "d-none"
                                        : "d-flex flex-grow align-items-center"
                                }>
                                <div className={"me-2 me-md-0 d-flex"}>
                                    {this.props.supplierModel.settings?.screens?.orders?.hide_create || this.props.isReadOnly ? null : (
                                        <div>
                                            <OwButton
                                                hoverTitle={"create order"}
                                                disabled={this.state.disableCreateOrder}
                                                active={this.state.activeCreateOrder}
                                                leftIconClass="fas fa-plus"
                                                className="btn-warning d-print-none me-auto"
                                                title="create"
                                                fn={this.createNewOrderSidebar}
                                            />
                                        </div>
                                    )}

                                    {/*{this.props.supplierModel.guid === SupplierGuidEnum.STRAP_ITS &&*/}
                                    {/*this.props.userModel.isSupplierUser &&*/}
                                    {/*this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN ? (*/}
                                    {/*    <div className={"ms-2"}>*/}
                                    {/*        <OwToggle*/}
                                    {/*            fn={this.toggleCreateOrderSidebar}*/}
                                    {/*            name={"defaultCreateOrderSidebar"}*/}
                                    {/*            label={"new_create_order_sidebar"}*/}
                                    {/*            active={this.state.newCreateOrderSidebar}*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*) : null}*/}
                                </div>

                                <div className={"ms-auto d-flex align-items-center"}>
                                    {this.props.supplierModel.has_currencies ? (
                                        <OwToggle
                                            fn={this.toggleCurrencyConversions}
                                            name={"toggle_currency_conversions"}
                                            label={"currency_conversions"}
                                            active={this.state.doCurrencyConversion}
                                        />
                                    ) : null}
                                    {this.props.showHiddenFeatures ? (
                                        <div className={"ms-2"}>
                                            <OwToggle
                                                fn={this.toggleSequelize}
                                                name={"toggle_sequelize"}
                                                label={"sequelize"}
                                                active={this.state.useSequelize}
                                            />
                                        </div>
                                    ) : null}
                                    {this.props.userModel.isSupplierUser && this.props.userModel.userType?.id === UserTypesEnum.ADMIN ? (
                                        <div className={"justify-content-end d-none d-md-flex"}>
                                            <FieldsetActions
                                                title={"csv"}
                                                actions={[
                                                    {
                                                        fn: this.downloadCsvTemplate,
                                                        name: "download",
                                                        leftIconClass: "fas fa-download",
                                                    },
                                                    {
                                                        fn: this.showUploadModal,
                                                        name: "upload",
                                                        btnClass: "btn-danger ms-2",
                                                        leftIconClass: "fas fa-upload",
                                                    },
                                                ]}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            {/* Legacy / FilterBar (v2) search toggle, and the portal target for the v2 Refresh + Filters buttons.
                                Kept outside the order-entry wrapper above, which is hidden (d-none) for read-only users and
                                vendor users without order entry, so the v2 search stays usable for them. */}
                            <div className={"ms-auto d-flex align-items-center"}>
                                <FilterBarVersionToggle className={"ms-3"} />
                                <div id={"orders-filter-actions"} className={"d-flex align-items-center ms-2 d-print-none"} />
                            </div>
                        </div>

                        {/* This needs to be reconsidered, as print view could be helpful. */}
                        <span className={"ms-auto d-none"}>
                            <OwPrintButton />
                        </span>

                        <span className={this.props.supplierModel.has_exports ? "ms-2 d-inline-flex d-print-none" : "d-none"}>
                            <ExportDetail isVisible={showCheckBoxes} orders={this.state.exportOrders} fn={this.openExportsSidebar} />
                        </span>
                    </div>
                );
            }
        }
    };

    /**
     * Function to build the Data View on Mobile.
     */
    getMobileDataView = (getOffline: boolean = false) => {
        if (this.state.isOnline && navigator.onLine && !getOffline) {
            if (!this.state.orders.length && !this.state.initialFetch) {
                return (
                    <div>
                        <div className={"text-center"}>
                            <OwTitle title={"no_results"} tag={"h5"} />
                        </div>
                    </div>
                );
            } else if (this.state.initialFetch) {
                return (
                    <div>
                        <div className={"text-center"}>
                            <OwTitle title={"loading"} tag={"h5"} rightIconName={"fas fa-sync fa-spin"} />
                        </div>
                    </div>
                );
            } else {
                const hasShippingLeadTime = !!this.props.supplierModel!.shipping_lead_time;

                return _.map(this.state.orders, (order, index) => {
                    let orderState;

                    if (!_.isNil(order.Order_State)) {
                        const orderStateName = _.toLower(order.Order_State.name);

                        orderState = (
                            <FormattedMessage
                                id={`${orderStateName}`}
                                defaultMessage={`${orderStateName}`}
                                description="Order Status Title"
                            />
                        );
                    }

                    let notSubmitted = false;
                    let estimatedShippingAt;

                    if (hasShippingLeadTime) {
                        if (!_.isNil(order.estimated_shipping_at)) {
                            estimatedShippingAt = moment(order.estimated_shipping_at).format("MM/DD/YYYY");
                        } else {
                            notSubmitted = true;
                        }
                    }

                    const checked = _.get(this.state.checkBoxChecked, `[${index}].checked`, false);

                    return (
                        <div key={order.guid} className={"col-12 p-3 mobileOrderCard mt-2 mb-4"}>
                            <div className={"d-flex justify-content-end"}>
                                <OwCheckbox
                                    checked={checked || this.state.selectAll}
                                    label={""}
                                    labelClassName={"mb-0"}
                                    name={""}
                                    fn={() => {
                                        this.toggleCheckBox(order, index);
                                    }}
                                />{" "}
                            </div>
                            <h4>
                                <Link title={"Order Entry"} to={`/orders/${order.guid}/entry`}>
                                    {order.name}
                                </Link>
                            </h4>
                            <div>{order.Vendor?.name}</div>
                            <div>{orderState}</div>
                            <div className={hasShippingLeadTime ? "" : "d-none"}>
                                <div>
                                    <OwLabel isBold={true} title={"est_ship_date"} className={"me-3"} />
                                    {estimatedShippingAt}
                                    <div className={notSubmitted ? "" : "d-none"}>
                                        <OwLabel className={"text-small text-muted"} title={"not_submitted"} />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <OwLabel isBold={true} title={"last_updated"} className={"me-3"} />
                                {UserService.parseDate(order.updated_at)}
                            </div>
                        </div>
                    );
                });
            }
        } else {
            if (!this.state.offlineOrders.length && !this.state.initialFetch) {
                return (
                    <div>
                        <div className={"text-center"}>
                            <OwTitle title={"no_results"} tag={"h5"} />
                        </div>
                    </div>
                );
            } else if (this.state.initialFetch) {
                return (
                    <div>
                        <div className={"text-center"}>
                            <OwTitle title={"loading"} tag={"h5"} rightIconName={"fas fa-sync fa-spin"} />
                        </div>
                    </div>
                );
            } else {
                return _.map(this.state.offlineOrders, (order: IOfflineOrder, index: number) => {
                    return (
                        <div
                            key={order.offlineGuid}
                            className={"col-12 p-3 mobileOrderCard mt-2 mb-4 " + (index % 2 ? "charcoal-grey-two-bg" : "")}>
                            <h4>
                                <Link to={`/orders/${order.offlineGuid}/entry`}>
                                    <OwLabel title={"offline_order"} /> {order.offlineId}
                                </Link>
                            </h4>
                            <div>{order.Vendor.name}</div>
                            <div>
                                <OwLabel isBold={true} title={"last_updated"} className={"me-3"} />
                                {UserService.parseDate(order.updatedAt)}
                            </div>
                        </div>
                    );
                });
            }
        }
    };

    toggleSmallTable = (isSmallTable: boolean) => {
        this.setState({
            isSmallTable,
        });
    };

    /** OR-1486: whether the Tracking # column is showing (its data is only requested from the API while it is). */
    isTrackingColumnOn = (): boolean => {
        return !!this.state.columns.tracking?.isChecked && !this.props.is_quotes && !this.props.is_templates;
    };

    setColumns = (columns: IColumns) => {
        const tableCols = [...this.state.tableCols];
        // Tracking # on while the loaded page was fetched without shipments: refetch so the column fills in. The
        // previous state cannot be compared here, because the column picker mutates the shared nested column object.
        const needsShipments = !!columns.tracking?.isChecked && this.state.orders.some((order: IOrder) => _.isNil(order.Shipments));

        this.setState(
            {
                tableCols,
                columns,
            },
            () => {
                if (needsShipments && this.isTrackingColumnOn()) {
                    this.getOrdersRest("setColumns");
                }
            }
        );
    };

    getOrdersHTMLTable = (theadRow: any, tbodyRows: any, mobileDataView: any, isOfflineView: boolean) => {
        let tableClass = "table-dark";

        if (UIService.isMainViewLight()) {
            tableClass = "";
        }

        const offlineCols: IOwTableCols[] = [
            {
                title: "",
                isActionsCol: true,
                renderFn: this.renderOfflineActionsFn,
                renderFnEmitsRow: true,
                valueProp: "",
            },
            {
                title: "vendor",
                valueProp: "Vendor",
                valueSubProp: "name",
                isVendorOverride: true,
            },
            {
                title: "name",
                valueProp: "name",
                renderFn: this.renderOfflineName,
                renderFnEmitsRow: true,
            },
            {
                title: "catalog",
                valueProp: "Catalog",
                valueSubProp: "name",
            },
            {
                title: "price_group",
                valueProp: "Price_Group",
                valueSubProp: "value",
            },
            {
                title: "po_no",
                valueProp: "po_no",
            },
        ];

        return (
            <div className={"row mt-1"}>
                <div className="col-12">
                    {isOfflineView ? (
                        <div className={"d-flex align-items-baseline"}>
                            <OwTitle title={"offline_orders"} tag={"h4"} className={"me-2"} />
                            {this.state.isOnline && navigator.onLine ? (
                                <Link to={`/sync`} className={"pointer"}>
                                    <OwLabel leftIconClass={"fad fa-sync"} title={"sync"} className={"pointer"} />
                                </Link>
                            ) : null}
                        </div>
                    ) : null}

                    <OwTable
                        rowIdName={"offline-row"}
                        columns={offlineCols}
                        dataSet={this.state.offlineOrders}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={false}
                        initialData={false}
                        tableConfig={{ tableHover: true }}
                    />
                    {/*<table*/}
                    {/*    ref="table"*/}
                    {/*    className={*/}
                    {/*        tableClass +*/}
                    {/*        " orders-table table table-striped table-hover d-none d-md-table " +*/}
                    {/*        (this.state.isSmallTable ? "table-sm" : "")*/}
                    {/*    }>*/}
                    {/*    <thead>*/}
                    {/*        <tr>{theadRow}</tr>*/}
                    {/*    </thead>*/}
                    {/*    <tbody>{tbodyRows}</tbody>*/}
                    {/*</table>*/}

                    <div className={"d-block d-md-none"}>{mobileDataView}</div>

                    {!isOfflineView && this.state.totalOrders ? (
                        <PaginationBar
                            offset={this.state.offset}
                            limit={this.state.limit}
                            totalRecords={this.state.totalOrders}
                            onPaginationChanged={this.paginationChanged}
                        />
                    ) : null}
                </div>
            </div>
        );
    };

    getOfflineTableHeaderRow = () => {
        return (
            <React.Fragment>
                <th></th>
                <th>
                    <OwLabel title={"client"} />
                </th>
                <th>
                    <OwLabel title={"vendor"} supplierModel={this.props.supplierModel} isSupplierVendorOverride={true} />
                </th>
                <th>
                    <OwLabel title={"name"} />
                </th>
                <th>
                    <OwLabel title={"catalog"} />
                </th>
                <th>
                    <OwLabel title={"price_group"} />
                </th>
                <th>
                    <OwLabel title={"po_no"} />
                </th>
                <th></th>
            </React.Fragment>
        );
    };

    rowHasDetailView = (row: IOrderUI): boolean => {
        let hasDetailView = false;

        if (this.props.userModel.isSupplierUser && row.Pick_Lists && row.Pick_Lists.length) {
            const pickLists = row.Pick_Lists.filter((pickList) => pickList.deleted_at === null);

            if (pickLists.length) {
                hasDetailView = true;
            }
        }

        return hasDetailView;
    };

    getDetailViewComponent = (row: IOrderUI) => {
        console.log("getDetailViewComponent...: ", row.name);

        return <OrderDetailView order={row} />;
    };

    getOnlineOrdersTable = () => {
        const mobileDataView = this.getMobileDataView();

        const currentToken = UserService.getCurrentToken(this.props.userModel);

        return (
            <div>
                <div className={"table-responsive position-relative d-none d-md-block"}>
                    <ConfirmDeleteOverlayFn
                        targetElem={this.state.sourceElementRef}
                        handleConfirm={this.commitDelete}
                        handleCancel={this.cancelDelete}
                        message={"confirm_delete_order"}
                        leftAdjustment={0}
                        nestedParentElem={"orders-table"}
                        skipMainView={true}
                    />

                    <OwTable
                        id={"orders-table"}
                        columns={this.state.tableCols}
                        dataSet={this.state.orders}
                        totalRows={this.state.totalOrders || 0}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.isDataFetching}
                        initialData={this.state.isInitialData}
                        tableConfig={{
                            tableHover: true,
                            tableStriped: true,
                            tableSmall: this.state.isSmallTable,
                            tableHasSort: true,
                            hasDetailView: true,
                            stickyHeader: currentToken?.settings?.orders_fixed_header || false,
                            stickyHeaderMaxHeight: this.state.isSearchSectionVisible ? "50vh" : "70vh",
                        }}
                        currentSortCol={this.state.sortCol}
                        checkAllFn={this.props.userModel.isSupplierUser ? this.checkAll : undefined}
                        rowDetailViewFn={this.rowHasDetailView}
                        detailViewComponent={this.getDetailViewComponent}
                    />
                </div>

                <div className={"d-block d-md-none"}>{mobileDataView}</div>

                {this.state.isOnline && navigator.onLine && this.state.totalOrders ? (
                    <PaginationBar
                        limitArr={[
                            { value: 5, isSelected: false },
                            { value: 10, isSelected: false },
                            { value: 25, isSelected: false },
                            { value: 50, isSelected: false },
                            { value: 100, isSelected: false },
                            { value: 250, isSelected: false },
                            { value: 500, isSelected: false },
                            { value: 750, isSelected: false },
                            { value: 1000, isSelected: false },
                            { value: 1250, isSelected: false },
                            { value: 1500, isSelected: false },
                        ]}
                        offset={this.state.offset}
                        limit={this.state.limit}
                        totalRecords={this.state.totalOrders}
                        onPaginationChanged={this.paginationChanged}
                        isActive={this.state.isDataFetching}
                        tokenLimit={this.state.tokenLimit}
                        tokenLimitProp={"orders_page_size"}
                        tokenGuid={this.state.currentTokenGuid}
                    />
                ) : null}
            </div>
        );
    };

    downloadCsvTemplate = () => {
        let vendorTitle = "vendor";

        const headerRow = ["Sequence", "Catalog", "Price Group", "Item", "Qty"];

        if (this.props.supplierModel.has_expedited) {
            headerRow.push("Expedited");
        }

        if (this.props.supplierModel.has_service_levels) {
            headerRow.push("Service Level");
        }

        if (this.props.supplierModel.has_third_party_order_ref) {
            headerRow.push("Third Party Order Ref.");
        }

        if (!_.isString(this.props.supplierModel.settings) && this.props.supplierModel.settings.order_details) {
            const orderDetails = this.props.supplierModel.settings.order_details;

            for (const detail of orderDetails) {
                const title = _.startCase(detail);

                headerRow.push(title);
            }
        }

        if (this.props.supplierModel.vendor_name_override) {
            if (!_.isNil(this.props.supplierModel.vendor_name_override)) {
                vendorTitle = vendorTitle.replace(/vendor/g, this.props.supplierModel.vendor_name_override);
            }
        }

        headerRow.push(
            _.startCase(vendorTitle),
            "Address Line One",
            "Address Line Two",
            "Address Line Three",
            "City",
            "State",
            "Postal Code",
            "Country"
        );

        if (this.props.supplierModel.has_client_module) {
            headerRow.push(
                "End Client",
                "End Client Address Line One",
                "End Client Address Line Two",
                "End Client Address Line Three",
                "End Client City",
                "End Client State",
                "End Client Postal Code",
                "End Client Country"
            );
        }

        const rows = [headerRow];

        const csvContent = "data:text/csv;charset=utf-8," + rows.map((e) => e.join(",")).join("\n");

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "orderwerks-bulk-orders.csv");

        link.click();
    };

    /**
     * Download Orders Screen Data
     */
    downloadOrdersScreen = () => {
        const expectedOrder: string[] = ["total", "order", "name"];

        if (this.props.supplierModel.has_order_categories) {
            expectedOrder.push("order_categories");
        }

        expectedOrder.push("price_group", "user", "workflow", "status", "description", "po_no");

        if (this.props.supplierModel.has_delivery_deadlines) {
            expectedOrder.push("delivery_date");
        }

        expectedOrder.push("created_at", "due_date", "est_ship_date", "last_updated_at");

        const headerRow: string[] = [];

        const rowDetails: string[] = [];

        if (this.state.columns) {
            for (const orderItem of expectedOrder) {
                const column = this.state.columns[orderItem];

                if (column.isChecked && !column.notVisible) {
                    if (column.label === "order") {
                        if (this.props.is_quotes) {
                            column.label = "quote";
                            column.name = "quote_name";
                        }

                        // if (this.props.supplierModel.order_name_override) {
                        //     column.label = this.props.supplierModel.order_name_override;
                        //     column.name = this.props.supplierModel.order_name_override;
                        // }
                    }
                    if (
                        this.props.supplierModel.order_name_override &&
                        column.label.replace(this.props.supplierModel.order_name_override, "order") === "order"
                    ) {
                        column.label = "order";
                        column.name = "order_name";
                    }
                    headerRow.push(column.label);
                    rowDetails.push(column.name);
                }
            }
        }

        const rows: any[] = [headerRow];

        const orderRows = this.state.orders.map((order) => {
            const row: any = {};

            for (const rowDetail of rowDetails) {
                switch (rowDetail) {
                    case "order_name":
                    case "quote_name":
                        row[rowDetail] = order.name || "";
                        break;

                    case "total":
                        row[rowDetail] = order.grand_total || 0;
                        break;

                    case "order_categories":
                        row[rowDetail] = order.Category?.name || "";
                        break;

                    case "vendor":
                    case "customer":
                    case "dealer":
                    case "reseller":
                    case "retailer":
                        row[rowDetail] = order.Vendor?.name || "";
                        break;

                    case "price_group":
                        row[rowDetail] = order.Price_Group?.value || "";
                        break;

                    case "user":
                        row[rowDetail] = order.User?.name || "";
                        break;

                    case "workflow":
                        row[rowDetail] = order.Workflow?.name || "";
                        break;

                    case "status":
                        {
                            const orderState = (order.Order_State?.name || "").toLowerCase();
                            const orderStateTranslated = this.props.intl.formatMessage({ id: orderState });
                            row[rowDetail] = orderStateTranslated;
                        }
                        break;

                    case "description":
                        row[rowDetail] = order.description || "";
                        break;

                    case "po_no":
                        row[rowDetail] = order.po_no || "";
                        break;

                    case "delivery_date":
                        row[rowDetail] = order.delivery_date ? UserService.parseUTCDate(order.delivery_date) : "";
                        break;

                    case "created_at":
                        row[rowDetail] = order.created_at ? UserService.parseLastUpdated(order.created_at) : "";
                        break;

                    case "due_date":
                        row[rowDetail] = order.due_date ? UserService.parseLastUpdated(order.due_date) : "";
                        break;

                    case "est_ship_date":
                        row[rowDetail] = order.estimated_shipping_at ? UserService.parseLastUpdated(order.estimated_shipping_at) : "";
                        break;

                    case "updated_at":
                        row[rowDetail] = order.updated_at ? UserService.parseLastUpdated(order.updated_at) : "";
                        break;

                    default:
                        console.log("unable to find: ", rowDetail);
                        break;
                }
            }

            return row;
        });

        rows.push(...orderRows);

        const workbook = new ExcelJS.Workbook();
        const ws = workbook.addWorksheet(this.props.is_quotes ? "Quotes" : "Orders");

        const columns: any[] = [];

        for (const rowDetail of rowDetails) {
            const translated = this.props.intl.formatMessage({ id: rowDetail });

            columns.push({ header: translated, key: rowDetail });
        }

        ws.columns = columns;

        // make all of the headers row bold?

        for (const row of orderRows) {
            ws.addRow(row);
        }

        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;

            let filename = `orderwerks-orders-screen.xlsx`;

            if (this.props.is_quotes) {
                filename = `orderwerks-quotes-screen.xlsx`;
            }

            anchor.download = filename;
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    };

    dismissProcessedDetails = () => {
        this.setState({
            processedItemsDetails: null,
        });
    };

    saveSearchFiltersAsDefault = (filters: { [key: string]: string | boolean }) => {
        const currentToken = UserService.getCurrentToken(this.props.userModel);

        if (currentToken) {
            const payload: IUpdateTokenSettingsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                settings: {
                    orders_filters: filters,
                },
                tokenGuid: currentToken.guid,
            };

            this.props.socket.emit(EndpointsEnum.TokenUpdateSettings, payload);
        }
    };

    saveColumnsAsDefault = (columns: IColumns, sortCol?: string, sortOrder?: SortOrderEnum, fixedHeader?: boolean) => {
        const orderCols: { [key: string]: boolean } = {};

        for (const prop of Object.keys(columns)) {
            orderCols[prop] = columns[prop].isChecked;
        }

        const currentToken = UserService.getCurrentToken(this.props.userModel);

        if (currentToken) {
            const payload: IUpdateTokenSettingsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                settings: {
                    orders_cols: orderCols,
                    // @ts-expect-error
                    orders_sort_col: sortCol,
                    orders_sort_dir: sortOrder,
                    orders_fixed_header: fixedHeader,
                },
                tokenGuid: currentToken.guid,
            };

            this.props.socket.emit(EndpointsEnum.TokenUpdateSettings, payload);
        }

        if (sortCol || sortOrder) {
            this.setState({
                sortOrder: sortOrder || SortOrderEnum.DESC,
                sortCol: sortCol || "updated_at",
            });
        }
    };

    onUpdateTokenSettings = (data: IOnUpdateTokenSettingsDTO) => {
        const notification: INotification = {
            message: "successfully_updated_settings",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.toggleSortDir(this.state.sortCol, this.state.sortOrder);
    };

    getAvailSortCol = () => {
        const availSortCol = [
            { title: "catalog", value: "catalog" },
            { title: "total", value: "grand_total" },
            { title: SupplierService.updateStringWithOrderNameOverride("order", this.props.supplierModel), value: "name" },
        ];

        if (this.props.userModel.isSupplierUser) {
            availSortCol.push({
                title: SupplierService.updateStringWithVendorOverride("vendor", this.props.supplierModel),
                value: "Vendor.name",
            });
        }

        availSortCol.push({ title: "created_at", value: "created_at" }, { title: "updated_at", value: "updated_at" });

        return availSortCol;
    };

    render() {
        const tbodyRows = <tr />;

        let offlineTheadRow = <td />;

        let offlineTbodyRows = <tr />;

        const showCheckBoxes = this.getShowCheckboxes();

        if (
            this.state.isOnline &&
            navigator.onLine &&
            !_.isNil(this.state.orders) &&
            this.state.orders.length &&
            this.props.supplierModel &&
            this.props.userModel
        ) {
            if (this.state.hasOfflineOrders) {
                offlineTheadRow = this.getOfflineTableHeaderRow();
                offlineTbodyRows = (
                    <StandardOfflineOrder orders={this.state.offlineOrders} toggleConfirmDelete={this.toggleConfirmDelete} />
                );
            }
        } else {
            if (!this.state.isOnline || !navigator.onLine) {
                offlineTheadRow = this.getOfflineTableHeaderRow();
                offlineTbodyRows = (
                    <StandardOfflineOrder orders={this.state.offlineOrders} toggleConfirmDelete={this.toggleConfirmDelete} />
                );

                // console.log("Not Online tbodyRows", tbodyRows);
            }
        }

        this.overlayRow = (
            <div className="overlayRow align-items-center">
                <div>
                    <span className="ms-2">Are you sure you want to delete this order?</span>
                    <div className="btn-group">
                        <OwButton className={"btn-danger ms-2"} fn={this.commitDelete} centerIconClass={"far fa-trash-alt"} />
                        <OwButton className={"btn-secondary"} fn={this.cancelDelete} centerIconClass={"far fa-times"} />
                    </div>
                </div>
            </div>
        );

        // Show the Print View Component
        if (this.state.printView) {
            return (
                <div>
                    <div className={"d-flex justify-content-between align-items-center"}>
                        <OwButton
                            fn={this.togglePrintView}
                            className={"btn-primary mt-2 d-print-none"}
                            leftIconClass={"fas fa-chevron-left"}
                            title={"back"}
                        />

                        <OwPrintButton />
                    </div>

                    {this.state.printViewComponent}
                </div>
            );
        }

        const sectionTitle = this.getSectionTitle(showCheckBoxes);
        let normalView: any = null;

        let mobileDataView: any = null;
        let offlineMobileDataView: any = null;

        let has_quotes = false;

        if (this.props.supplierModel && this.props.supplierModel.has_quotes) {
            has_quotes = true;
        }

        const has_templates = !!this.props.supplierModel.has_templates;

        const forceOnline = UserService.getForceOnline();

        if (this.props.userModel) {
            mobileDataView = this.getMobileDataView();
            offlineMobileDataView = this.getMobileDataView(true);

            const currentToken = UserService.getCurrentToken(this.props.userModel);

            normalView = (
                <div className="orders position-relative" id={"orders"}>
                    {/*<Breadcrumbs navItems={this.state.navItems} />*/}

                    <OwProcessedItemsDetails
                        details={this.state.processedItemsDetails}
                        dismissProcessedDetails={this.dismissProcessedDetails}
                    />

                    <div className="row">
                        <div className="col-12 d-flex align-items-center justify-items-center">{sectionTitle}</div>
                    </div>

                    {this.state.qboInvoiceSyncProgress !== undefined && (
                        <div className="d-flex justify-content-end d-print-none">
                            <QboInvoicesSyncStatus progress={this.state.qboInvoiceSyncProgress} />
                        </div>
                    )}

                    {(this.state.isOnline && navigator.onLine) || forceOnline ? (
                        <div className="row">
                            <div className="col-12">
                                {/* FilterBar (v2) ships on Orders, Quotes and Templates behind the per-user toggle. */}
                                {getFilterBarMode(currentToken?.settings).useFilterBar ? (
                                    <OrdersFilterBar
                                        catalogs={this.state.catalogs}
                                        hasQuotes={has_quotes}
                                        hasTemplates={has_templates}
                                        isQuotes={!!this.props.is_quotes}
                                        isTemplates={!!this.props.is_templates}
                                        isSearching={this.state.isDataFetching}
                                        searchFn={this.filterOrders}
                                        currentQueryStringArr={this.setCurrentQueryStringArr}
                                    />
                                ) : (
                                    <SearchSection
                                        onToggleVisibleFn={(isVisible) => {
                                            this.setState({
                                                isSearchSectionVisible: isVisible,
                                            });
                                        }}>
                                        <OrderFilter
                                            saveAsDefaults={this.saveSearchFiltersAsDefault}
                                            socket={this.props.socket}
                                            searchFn={this.filterOrders}
                                            currentQueryStringArr={this.setCurrentQueryStringArr}
                                            is_quotes={!!this.props.is_quotes}
                                            is_templates={!!this.props.is_templates}
                                            has_quotes={has_quotes}
                                            has_templates={has_templates}
                                            isVisible={this.state.isOnline && navigator.onLine}
                                            supplierModel={this.props.supplierModel}
                                            userModel={this.props.userModel}
                                            vendorModel={this.props.vendorModel}
                                            catalogs={this.state.catalogs}
                                            isActive={this.state.isDataFetching}
                                            history={this.props.history}
                                            location={this.props.location}
                                        />
                                    </SearchSection>
                                )}
                            </div>
                        </div>
                    ) : null}

                    {this.props.supplierModel.settings?.screens?.orders?.hide_action_buttons ? null : (
                        <div className={"row mt-1"}>
                            <div className="col-12">
                                <div className={"d-print-none"}>
                                    <OwActionBar
                                        isQuotes={this.props.is_quotes}
                                        isTemplates={this.props.is_templates}
                                        actions={this.state.actions}
                                        disabled={!this.state.hasOneChecked}
                                        toggleSmallTable={this.toggleSmallTable}
                                        columns={this.state.columns}
                                        colToggledFn={this.setColumns}
                                        totalValue={this.state.totalOrders}
                                        saveAsDefaultsFn={this.saveColumnsAsDefault}
                                        sortOrder={currentToken?.settings?.orders_sort_dir || SortOrderEnum.DESC}
                                        sortCol={currentToken?.settings?.orders_sort_col || "updated_at"}
                                        availSortCol={this.getAvailSortCol()}
                                        showFixedHeader={true}
                                        fixedHeader={currentToken?.settings?.orders_fixed_header || false}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {
                        // this is hte offline orders table that's part of the online view
                        this.state.hasOfflineOrders && navigator.onLine && this.state.isOnline ? (
                            <div>
                                {this.getOrdersHTMLTable(offlineTheadRow, offlineTbodyRows, offlineMobileDataView, true)}
                                <hr />
                            </div>
                        ) : null
                    }

                    {
                        // this is hte offline orders table that's part of the offline view
                        !this.state.isOnline || !navigator.onLine
                            ? this.getOrdersHTMLTable(offlineTheadRow, offlineTbodyRows, mobileDataView, true)
                            : null
                    }

                    {(this.state.isOnline && navigator.onLine) || forceOnline ? this.getOnlineOrdersTable() : null}

                    <div>
                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={(e: any) => {
                                this.closeModal();
                            }}
                            contentLabel="Orderwerks"
                            shouldCloseOnOverlayClick={false}
                            className={"modalContentClass"}
                            overlayClassName={"modalOverlayClass"}
                            style={{}}>
                            {this.state.modalComponent}
                        </Modal>
                    </div>

                    <Dock
                        size={1}
                        dockStyle={{ backgroundColor: "white", color: "black" }}
                        position="bottom"
                        isVisible={this.state.isDockVisible}>
                        {" "}
                        <div className={"p-2"}>
                            <div className="text-end d-print-none">
                                <span className="pointer" onClick={this.toggleDock}>
                                    X
                                </span>
                            </div>

                            <div className="">{this.state.dockComponent}</div>
                        </div>
                    </Dock>
                </div>
            );
        }

        return normalView;
    }
}

export default Orders;
